<template>
  <Loading
    :contentSize="true"
    :state="loading"
    :stop="loadingStop"
  >
    <TableUni
      v-if="columns !== null"
      :title="''"
      :columns="columns"
      :rows="rows"
      :itemsPerPage="limit"
      :page="page"
      :pages="pages"
      :itemsRecount="rowsCount"
      :sortEnable="true"
      :filtersColumnsEnable="true"
      :wrapHeaders="true"
      :wrap="true"
      :reload="reloadTable"
      :externalData="true"
      :columnsOrderAndSelectionEnable="true"
      :XLSexport="permitted( 'XLSexport', endpointId, classId ) && XLSexport"
      :XLSimport="permitted( 'XLSimport', endpointId ) && XLSimport"
      :validation="filtersValidate"
      :rowColClick="rowColClick"
      @update="tableUpdate"
      @recount="rowsRecount"
      :show="true"
      class="tableMain"
      ref="main"

      :colGetClass="colGetClass"
      :colGetTitle="colGetTitle"
    >
      <template v-slot:col="{ data }">
        <div
          class="control opened"
          :class="columnGetAlign( data.columnId )"

          :key="`${data.row.id}_control_${data.columnId}`"
        >
          {{ data.value.own }}
          <div class="inferred" v-if="data.value.inferred && data.value.inferred.length">
            {{ data.value.inferred }}
          </div>
          <Tooltip
            orientation="bottom"
            :anglePosition="editingDataProp( data.row.id, data.columnId, 'anglePosition', 'start' )"
            class="fields"
            :class="editingDataProp( data.row.id, data.columnId, 'class', '' )"
            :show="editingIs( data.row.id, data.columnId )"
            :closeIcon="false"
            resize="horizontal"
            @closed="editingSet( $event, data, false )"
          >
            <template v-if="editingIsValues( data.row.id, data.columnId )">
              <div
                class="field"
                v-for="( v, vk ) in editingData( data.row.id, data.columnId ).values"
                :key="vk"
                style="will-change: transform"
              >
                <span class="lang">{{ $langBrief( v.lang ) }}</span>
                <DVfield
                  class="fieldDV"
                  :type="columnGetType( data.columnId )"
                  :refs="columnGetClasses( data.columnId )"
                  :misc="{ URL: '/editing/ac', params: apiQueryStd }"

                  :ref="'DVfields_' + data.row.id + '_' + data.columnId"

                  :value="editingValGet( data.row.id, data.columnId, vk )"

                  :disabled="!permitted( 'objUpd', endpointId ) && ( !permitted( 'objCrt', endpointId ) || !data.row.new )"

                  @input="editingValSet( data.row.id, data.columnId, vk, $event )"
                  @ok="editingSave( data.row.id, data.columnId )"

                  @error="editingDataErrorSet( data.row.id, data.columnId, $event, vk )"
                />
                <button
                  v-if="editingFieldCanRemove( data.row.id, data.columnId ) && ( permitted( 'objUpd', endpointId ) || ( permitted( 'objCrt', endpointId ) && data.row.new ) )"

                  @click="editingFieldRemove( $event, data.row.id, data.columnId, vk )"
                  :title="$t( 'ValueRemove' )"
                >
                  <Icon
                    symbol="removeBold"
                    size="0.8em"
                  />
                </button>
                <button
                  v-if="editingFieldCanAdd( data.row.id, data.columnId ) && ( permitted( 'objUpd', endpointId ) || ( permitted( 'objCrt', endpointId ) && data.row.new ) )"

                  @click="editingFieldAdd( $event, data.row.id, data.columnId, vk )"
                  :title="$t( 'ValueAdd' )"
                >
                  <Icon
                    symbol="addBold"
                    size="0.8em"
                  />
                </button>
                <Tooltip
                  :show="!!editingDataErrorGet( data.row.id, data.columnId, vk )"
                  orientation="bottom"
                  type="error"
                  class="errorTip"
                  style="position: fixed"
                  @close="editingDataErrorClear( data.row.id, data.columnId, vk )"
                >
                  <span v-html="editingDataErrorGet( data.row.id, data.columnId, vk )"></span>
                </Tooltip>
              </div>
            </template>
            <template v-else>
              <div class="field empty">
                <button
                  @click="editingFieldAdd( $event, data.row.id, data.columnId, -1 )"
                  :title="$t( 'ValueAdd' )"
                  v-if="editingFieldCanAdd( data.row.id, data.columnId )"
                >
                  <Icon
                    symbol="add"
                    size="0.8em"
                  />
                </button>
              </div>
            </template>
            <div class="controls">
              <button
                v-if="permitted( 'objUpd', endpointId ) || ( permitted( 'objCrt', endpointId ) && data.row.new )"
                @click="editingSave( data.row.id, data.columnId )"
                :title="$t( 'ChangesSave' )"
              >
                <Icon
                  symbol="save"
                  size="1em"
                />
              </button>
              <button
                @click="editingDiscard( $event, data.row.id, data.columnId )"
                :title="$t( 'ChangesCancel' )"
              >
                <Icon
                  symbol="close"
                  size="1em"
                />
              </button>
            </div>

            <Tooltip
              :show="!!editingDataErrorGet( data.row.id, data.columnId )"
              orientation="bottom"
              type="error"
              class="errorTip"
              @close="editingDataErrorClear( data.row.id, data.columnId )"
            >
              <span v-html="editingDataErrorGet( data.row.id, data.columnId )"></span>
            </Tooltip>
          </Tooltip>
        </div>
      </template>
      <template v-slot:@&selection="{ data }">
        <Checkbox
          :value="data.rows.reduce( ( a, i ) => { if ( !i['selected'] ) a = false; return a; }, true )"
          @input="data.rows.forEach( i => { $set( i, 'selected', $event ); } )"
          :title="$t( 'MarkUnmarkAll' )"
          v-if="data.rows.length"
        />
        <span v-else>&#160;</span>
      </template>
      <template v-slot:&selection="{ data }">
        <Checkbox
            v-model="data.row['selected']"
        />
      </template>
      <template v-slot:&controls="{ data }">
        <span class="rowControls">
          <button
            @click="rowView( data.row.id )"
            :title="$t( 'ObjectView' )"
          >
            <Icon
              symbol="view"
            />
          </button>
          <button
            v-if="permitted( 'objCrt', endpointId )"

            :title="$t( 'RowAddAfter' )"

            @click="rowAdd( data.row.id )"
          >
            <Icon
              symbol="add"
            />
          </button>
          <button
            v-if="permitted( 'objDel', endpointId )"

            :title="$t( 'RowRemove' )"

            @click="rowDelete( data.row.id )"
          >
            <Icon
              symbol="remove"
            />
          </button>
          <button
            v-if="( permitted( 'objUpd', endpointId ) || ( permitted( 'objCrt', endpointId ) && data.row.new ) ) && ( data.row.new || editingRowIs( data.row.id ) )"
            @click="editingSave( data.row.id )"
            :title="$t( 'ChangesSaveAll' )"
          >
            <Icon
              symbol="save"
            />
          </button>
        </span>
      </template>
      <template v-slot:@&controls="{ data }">
      </template>
      <template v-slot:&id="{ data }">
        <div
          class="control opened"
          :class="data.row.idCorrLoading ? 'loading' : ''"
          v-if="data.row.new"
        >
          {{ data.row.id }}
          <Tooltip
            orientation="bottom"
            :anglePosition="'start'"
            class="fields"
            :show="!!data.row.idCorr"
            :closeIcon="false"
          >
            <div class="field">
              <DVfieldId
                class="fieldStandalone"
                v-model="data.row.idCorrVal"
                v-if="data.row.idCorrVal"
              />
            </div>
            <div class="controls">
              <button
                @click=""
                :title="$t( 'ChangesCancel' )"
              >
                <Icon
                  symbol="close"
                  size="1em"
                  @click.native="$delete( data.row, 'idCorr' )"
                />
              </button>
            </div>
          </Tooltip>
        </div>
        <template v-else>
          {{ data.row.id }}
        </template>
      </template>
      <template v-slot:@&id="{ data }">
        {{ $t( "URI" ) }}
      </template>
      <template slot="headerMisc">
        <div
          class="endpoint"
          :data-content="$t( 'Endpoint' )"
        >
          <select
            :value="endpointId"
            @input="reload( $event.target.options[ $event.target.selectedIndex ].value, null )"
          >
            <option v-if="endpoints" v-for="( endpointName, endpointId ) of endpoints" :key="endpointId" :value="endpointId">{{ endpointName }}</option>
          </select>
        </div>
        <DVclassSelect
          class="classSelect"
          :data-content="$t( 'Class' )"

          :id="classId"
          :name="endpointClassesGet( classId ).name"
          :params="{ ...apiQueryStd, lang: this.langInterf }"

          @selected="reload( undefined, $event )"
        />

        <template v-if="permitted( 'classMenu', endpointId )">
        <Dropdown
          v-if="classMenuS === null"
          class="hdrcontrol classMenu"
          :items="classMenuMsgGet( 'items' )"

          @input="classMenu( $event )"
        />
        <Circlebar
          v-else-if="Number.isInteger( classMenuProcessingPercentage )"

          class="hdrcontrol classMenuProcessing"

          :value="classMenuProcessingPercentage"
          :title="classMenuMsgGet( 'processing', true )"
        />
        <div
          v-else
          class="hdrcontrol classMenuProcessingInf"
          :title="classMenuMsgGet( 'processing', true )"
        >
          <Icon
            symbol="loading"
            size="2em"
          />
        </div>
        </template>

        <button
          v-if="permitted( 'objCrt', endpointId )"
          class="hdrcontrol"
          @click="rowAdd()"
          :title="$t( 'ObjectAdd' )"
        >
          <Icon
            symbol="addBold"
          />
        </button>
        <button
          v-if="permitted( 'objDel', endpointId )"
          class="hdrcontrol"
          @click="rowsDelete()"
          :title="$t( 'ObjectsMarkedDel' )"
        >
          <Icon
            symbol="removeBold"
          />
        </button>
        <button
          v-if="filtersSortsAppliedIs"
          class="hdrcontrol filtersSortsApplied"

          @click="filtersSortsRemove()"
          @mouseover="filtersSortsAppliedShow=true"
          @mouseout="filtersSortsAppliedShow=false"
        >
          <Icon
            symbol="filterRemove"
          />
          <Tooltip
            :show="filtersSortsAppliedShow"
            :closeIcon="false"
            :wrap="false"
            :interaction="false"

            class="tip"
            orientation="bottom"
          >
            <span v-html="filtersSortsApplied" />
          </Tooltip>
        </button>
        <div
          @click="$refs.qualityBar.contains( $event.target ) && qualityPageOpen()"

          class="quality"

          ref="quality"

          v-if="quality.total"

          :class="quality.active ? 'active' : ''"

          @mouseenter="$set( quality, 'tip', true )"
          @mouseleave="qualityMouseLeave( $event )"
        >
          <div class="bar" ref="qualityBar" :class="{ validEmpty: !quality.validPercent, invalidEmpty: quality.validPercent === 100 }"><div class="labelV">{{ quality.validPercent }}%</div><div class="band"><div class="valid" :style="{ width: quality.validPercent + 'px' }"></div><div class="invalid" :style="{ width: ( 100 - quality.validPercent ) + 'px' }"></div></div><div class="labelI">{{ 100 - quality.validPercent }}%</div></div>
          <Tooltip
            :show="quality.tip"
            :closeIcon="false"
            :wrap="false"
            :interaction="true"
            :pad="true"

            class="tip"
            orientation="bottom"
          >
            <div class="hdr">{{ $t( "DataQuality" ) }}</div>

            {{ $t( "TotalObjects" ) }}: <b>{{ quality.total }}</b><br />
            {{ $t( "ObjectsViolated" ) }}: <b>{{ quality.incorrect }}</b><br />

            <div class="shapes">
              <div class="header">{{ $t( "DataQualityShow" ) }}</div>
              <div
                :class="qualityGetClassName( sid )"

                v-for="( s, sid ) in quality.shapes"
                :key="sid"

                @click="quality.active != sid && qualitySetActive( sid )"
              >
                <span
                  class="name"
                >{{ s.name ? s.name : sid }}</span><span class="count">{{ s.count }}</span>
              </div>
            </div>
          </Tooltip>
        </div>

        <button
          v-if="permitted( 'scheduler', endpointId )"

          class="hdrcontrol"
          :title="$t( 'Scheduler' )"
          @click="schedulerOpen"
          style="font-size: 0.8em; cursor: pointer; font-weight: bold;"
        >
          <Icon
            symbol="scheduler"
            width="1.8em"
            height="1.8em"
          />
        </button>
      </template>
    </TableUni>

    <Modal
      :show="schedulerShow"
      :title="$t( 'Scheduler' )"
      acceptButtonText="Ok"
      cancelButtonText=""
      @accept="schedulerShow = false"
      @close="schedulerShow = false"
    >
      <Scheduler
        ref="scheduler"
        :params="schedulerParams"
        :active="schedulerShow"
      >
        <div class="schedulerControls">
          <div
            v-if="permitted( 'XLSimport', endpointId )"

            class="button"
            @click="schedulerXLSimport()"
            :title="$t( 'ImportXLS' )"
          >
            <Icon
              symbol="XLSimport"
              size="2em"
            />
            {{ $t( "ImportXLS" ) }}
          </div>

          <div
            v-if="permitted( 'XLSexport', endpointId, classId )"

            class="button"
            @click="schedulerXLSexport()"
            :title="$t( 'ExportXLS' )"
          >
            <Icon
              symbol="XLSexport"
              size="2em"
            />
            {{ $t( "ExportXLS" ) }}
          </div>
        </div>

        <Modal
          :show="schedulerXLSimportShow"
          :title="$t( 'ImportXLSfile' )"
          :acceptButtonText="$t( 'Import' )"

          @accept="schedulerXLSimportDo"
          @close="schedulerXLSimportClose"
          @cancel="schedulerXLSimportClose"
          @hided="schedulerXLSimportClose( true )"
        >
          <div class="group schedulerXLSimport">
            <File
              :multiple="true"
              :value="schedulerXLSimportData"
              @input="schedulerXLSimportRefresh( $event.el, $event.fn )"
            />
            <Tooltip
              :show="schedulerXLSimportError !== null"
              orientation="bottom"
              type="error"
              class="errorTip"

              @close="schedulerXLSimportError=null"
            >
              <span v-html="schedulerXLSimportError"></span>
            </Tooltip>
          </div>
          <Radio
            style="margin-top: 1em;"
            :column="true"
            :values="[
              { label: $t( 'importXLSappend' ),       tip: $t( 'ImportXLSappendTip' ),        value: 'append' },
              { label: $t( 'importXLSreplace' ),      tip: $t( 'ImportXLSreplaceTip' ),       value: 'replace' },
              { label: $t( 'importXLSsubstitution' ), tip: $t( 'ImportXLSsubstitutionTip' ),  value: 'substitution' }
            ]"
            v-model="schedulerXLSimportMode"
          />
          <Checkbox
            style="margin-top: 1em;"
            :value="schedulerApplyRules"
            @input="schedulerApplyRules=$event"
            :label="$t( 'importXLSrulesApply' )"
          />
        </Modal>
      </Scheduler>
    </Modal>


    <Modal
      :show="XLSimportShow"
      :title="$t( 'ImportXLSfile' )"
      :acceptButtonText="$t( 'Import' )"

      @accept="XLSimportDo"
      @close="XLSimportClose"
      @cancel="XLSimportClose"
      @hided="XLSimportClose( true )"
    >
      <div class="group">
        <File
          :value="XLSimportData"
          @input="XLSimportRefresh( $event.el, $event.fn )"
        />
        <Tooltip
          :show="XLSimportError !== null"
          orientation="bottom"
          type="error"
          class="errorTip"

          @close="XLSimportError=null"
        >
          <span v-html="XLSimportError"></span>
        </Tooltip>
      </div>
      <Radio
        style="margin-top: 1em;"
        :column="true"
        :values="[
          { label: $t( 'importXLSappend' ),       tip: $t( 'ImportXLSappendTip' ),        value: 'append' },
          { label: $t( 'importXLSreplace' ),      tip: $t( 'ImportXLSreplaceTip' ),       value: 'replace' },
          { label: $t( 'importXLSsubstitution' ), tip: $t( 'ImportXLSsubstitutionTip' ),  value: 'substitution' }
        ]"
        v-model="XLSimportMode"
      />
    </Modal>

    <Modal
      v-for="modal in modals"
      :key="modal.id"
      :show="modal.show"
      :title="modal.title"
      :acceptButtonText="modal.labelOk || modal.labelOk === '' ? modal.labelOk : $t( 'Ok' )"
      :cancelButtonText="modal.labelCancel || modal.labelCancel === '' ? modal.labelCancel : $t( 'Cancel' )"

      @hided="modalRemove( modal.id )"
      @close="modalEvent( 'close', modal.id )"
      @accept="modalEvent( 'ok', modal.id )"
      @cancel="modalEvent( 'cancel', modal.id )"
    >
      <span v-html="modal.content"></span>
    </Modal>

    <Modal
      :show="$route.name.includes( 'objectView' )"
      :emptyBodyUse="true"
      :acceptButtonText="$t( 'Close' )"
      :cancelButtonText="''"
      :scrollContent="false"
      :buttons="[]"

      class="objectViewModal"

      @close="rowViewClosed()"
      @accept="rowViewClosed()"
    >
      <router-view
        name="objectView"
        @refresh="reload()"
      />
    </Modal>

    <Modal
      :show="duplicateFindingRulesShow"
      :title="$t( 'DuplicateFindingRules' )"
      :acceptButtonText="$t( 'DuplicateFindingRulesApply' )"
      :cancel-button-text="$t( 'cancel' )"

      class="duplicateFindingRules"
      :class="duplicateFindingRules == null || !duplicateFindingRuleSelected ? 'disableAccept' : ''"


      @accept="classMenu( 'duplicatesApply' )"
      @close="duplicateFindingRulesShow = false"
      @cancel="duplicateFindingRulesShow = false"
    >
      <Loading
        :contentSize="true"
        :state="duplicateFindingRules == null"
      >
        <div
          class="rule"

          @click="duplicateFindingRuleSelected = id"

          :class="duplicateFindingRuleSelected == id ? 'selected' : ''"

          v-for="( name, id ) in duplicateFindingRules"
          :key="id"
        >
          {{ name }}
        </div>
        <div
          v-if="duplicateFindingRules !== null && !duplicateFindingRuleSelected"
        >
          {{ $t( "DuplicateFindingRulesEmpty" ) }}
        </div>
      </Loading>
    </Modal>

    <Modal
      :show="referencesRefreshingShow"
      :title="$t( 'ReferencesRefreshing' )"
      :acceptButtonText="$t( 'ReferencesRefreshingApply' )"
      :cancel-button-text="$t( 'cancel' )"

      class="referencesRefreshing"

      @accept="classMenu( 'referencesApply' )"
      @close="referencesRefreshingShow = false"
      @cancel="referencesRefreshingShow = false"
    >
      <Checkbox
        v-model="referencesRefreshingSetReferenceLink"
        :label="$t( 'referencesRefreshingSetReferenceLink' )"
      />
      <Checkbox
        v-model="referencesRefreshingWriteProvenance"
        :label="$t( 'referencesRefreshingWriteProvenance' )"
      />
    </Modal>

    <Modal
      :show="constraintsSearchingShow"
      :title="$t( 'ConstraintsSearching' )"
      :acceptButtonText="$t( 'ConstraintsSearchingApply' )"
      :cancel-button-text="$t( 'cancel' )"
      :scrollContent="false"

      class="constraintsSearching"

      @accept="classMenu( 'constraintsApply' )"
      @close="constraintsSearchingShow = false"
      @cancel="constraintsSearchingShow = false"
    >
      {{ $t( "constraintsSearchingSortClassSelector" ) }}
      <Autocompleter
        ref="constraintsSearchingSortField"
        :value="constraintsSearchingSortClass"
        @input="constraintsSearchingSortClass=$event"
        :getItems="constraintsSearchingSortItems"
        @ok="constraintsSearchingSortClass=$event"
      />
      <Tooltip
        :show="constraintsSearchingError !== null"
        orientation="bottom"
        type="error"
        class="errorTip"
        @close="constraintsSearchingError = null"
      >
        <span v-html="constraintsSearchingError"></span>
      </Tooltip>
    </Modal>
  </Loading>
</template>

<script>

//todo use values for flags like yes/no and kz values
//todo max - use date format like mm.dd.yy

import dates from "@/dates"
import utils from "@/utils"
import config from "@/config"
import ls from "@/ls"

import Loading from "@/components/Loading";
import TableUni from "@/components/TableUni";
import Icon from "@/components/Icon";
import Tooltip from "@/components/Tooltip";
import DVfield from "../components/DVfield";
import DVfieldId from "../components/DVfieldId";
import Checkbox from "../components/Checkbox";
import Radio from "../components/Radio";
import File from "../components/File";
import Modal from "../components/Modal";
import Autocompleter from "../components/Autocompleter";
import Dropdown from "../components/Dropdown";
import Circlebar from "../components/Circlebar";

import DVclassSelect from "@/components/DVclassSelect";
import frontbackUtils from "../frontbackUtils";
import DVfieldReference from "../components/DVfieldReference";

import Scheduler from "@/components/Scheduler";

export default {
  name: "pageTable",
  components: {
    DVfieldReference,
    Autocompleter,
    Checkbox,
    Radio,
    Loading,
    TableUni,
    Icon,
    Tooltip,
    Modal,
    File,
    Dropdown,
    Circlebar,

    DVfield,
    DVclassSelect,
    DVfieldId,

    Scheduler
  },
  i18n: {
    messages: {
      ru: {
        DataEditor:             "Редактирование объектов",
        Columns:                "Столбцы",
        ClassSelect:            "Выберите класс",
        Choose:                 "Выбор",
        ObjectAdd:              "Добавить объект",
        ObjectsMarkedDel:       "Удалить отмеченные",
        ImportXLSfile:          "Импорт файла из Excel",
        FileChoose:             "Выберите файл",
        importXLSappend:        "добавить значения к существующим",
        ImportXLSappendTip:     "Добавить значения к совпадающим, а также создать новые свойства объекта",
        importXLSreplace:       "перезаписывать значения существующих",
        ImportXLSreplaceTip:    "Перезаписать совпадающие и создать новые свойства объекта",
        importXLSsubstitution:  "полностью перезаписывать все свойства",
        ImportXLSsubstitutionTip:"Удалить все существующие, создать все загружаемые свойства объекта",
        importXLSrulesApply:    "применять правила",
        ValueRemove:            "Убрать значение",
        ValueAdd:               "Добавить еще значение",
        RowAddAfter:            "Добавить строку после",
        RowRemove:              "Удалить строку",
        PropHistoryShow:        "Показать историю изменений свойства",
        ChangesSaveAll:         "Сохранить все изменения в данной строке",
        EndpointsRequestError:  "Ошибка получения списка точек",
        ConsMandRequestErrors:  "Ошибка при запросе обязательных полей консолидации",
        ConsMandMsg:            "Обязательно для консолидации, должно быть заполнено",
        ClassesRequestError:    "Ошибка получения списка классов",
        InvalidDateFormat:      "Неверный формат даты",
        UseDateFormat:          "Используйте «дд.мм.гггг»",
        UseDatetimeFormat:      "Используйте «дд.мм.гггг чч:мм:сс»",
        InvalidFlagFormat:      "Неверный формат флага",
        UseFlagFormat:          "Используйте «да» или «нет»",
        InvalidIntegerFormat:   "Неверный формат целого числа",
        UseIntegerFormat:       "Используйте цифры и символ \"-\", если необходимо",
        InvalidDoubleFormat:    "Неверный формат вещественного числа",
        UseDoubleFormat:        "Используйте цифры и символы \"-\" и \".\", если необходимо",
        SchemaRequestError:     "Ошибка получения схемы",
        newObject:              "еще не созданный объект",
        ImportErrors:           "Ошибки импорта",
        importSucc:             "успешно импортирован",
        importErr:              "ошибка импорта файла",
        SelectFile:             "Необходимо выбрать файл",
        RefCantEmpty:           "Указатель не может быть пустым",
        RefFillOrRemove:        "Заполните его, или удалите поле с ним",
        MinFieldsFilled:        "Минимальное кол-во заполненных полей для данного объекта",
        FillMissingFields:      "Заполните недостающие поля",
        SavedObjectGetError:    "Ошибка получения объекта после сохранения",
        TotalObjects:           "Всего объектов",
        ObjectsViolated:        "Объектов с нарушениями",
        DataQuality:            "Качество данных",
        DataQualityOWV:         "Все нарушения",
        DataQualityALL:         "С нарушениями и без",
        DataQualityShow:        "Показать объекты со следующими нарушениями:",
        OperationFinished:      "Операция завершена",
        classMenu:              {
          items:      { constraints: "Применить правила проверки",                                                    duplicates: "Применить правило поиска дубликатов",          references: "Обновить эталонные объекты" },
          processing: { constraints: "Идет применение правил проверки...",                                            duplicates: "Идет применение правил поиска дубликатов...",  references: "Идет обновление эталонных объектов..." },
          finished:   { constraints: "Правила проверки применены.<br /><br /><b>Объектов с нарушениями на текущей странице: {count}</b>", duplicates: "Поиск дубликатов завершен.",                   references: "Эталонные объекты обновлены.<br /><br /><b>Создано/обновлено: {count}</b>" },
          error:      { constraints: "Ошибка применения правил проверки",                                             duplicates: "Ошибка поиска дубликатов",                     references: "Ошибка обновления эталонных объектов" }
        },

        DuplicateFindingRules:      "Выбор правила для поиска дубликатов",
        DuplicateFindingRulesApply: "Поиск дубликатов",
        DuplicateFindingRulesEmpty: "Не задано ни одного правила.",

        ReferencesRefreshing:       "Обновление эталонных объектов",
        ReferencesRefreshingApply:  "Обновление",

        referencesRefreshingSetReferenceLink:  "устанавливать ссылки",
        referencesRefreshingWriteProvenance:   "записывать происхождение",

        columnFilters: {
          modeEqual:      "=\u00a0\u00a0равенство",
          modeContains:   ".\u00a0\u00a0вхождение",
          modeLess:       "<\u00a0\u00a0меньше",
          modeLessEqual:  "<=\u00a0меньше или равно",
          modeMore:       ">\u00a0\u00a0больше",
          modeMoreEqual:  ">=\u00a0больше или равно",
          modeEmpty:      "\u2610\u00a0пусто",
          modeEmptyNot:   "\u2611\u00a0не пусто"
        },

        ConstraintsSearching:                 "Правила проверки",
        ConstraintsSearchingApply:            "Применить правила проверки",
        constraintsSearchingSortClassSelector:"Выбор поля по которому будет произведена сортировка",
        ConstraintsSearchingSpecifySort:      "Необходимо выбрать поле для сортировки.",

        ClassMenu:          "Идет процесс ",
        filtersSortsRemove: "нажмите для очистки всех фильтров и сортировки",

        XLSexportNoSort:    "Пожалуйста отсортируйте данные по какому-либо столбцу.",
        XLSimportLangWarn:  "Выбран язык \"{lang}\".<br /><br />Все импортируемые данные будут загружены с языковой меткой."
      },

      en: {
        DataEditor:             "Data editor",
        Columns:                "Columns",
        ClassSelect:            "Choose class",
        Choose:                 "Choose",
        ObjectAdd:              "Create object",
        ObjectsMarkedDel:       "Delete marked objects",
        ImportXLSfile:          "Import file from Excel",
        FileChoose:             "Choose file",
        importXLSappend:        "append values to existing properties",
        ImportXLSappendTip:     "Append values to matching and create new properties of an object",
        importXLSreplace:       "replace values of the existing ones",
        ImportXLSreplaceTip:    "Replace values of the existing and create new properties of an object",
        importXLSsubstitution:  "full replace all properties",
        ImportXLSsubstitutionTip:"Delete all existing and create all loaded properties of an object",
        importXLSrulesApply:    "apply the rules",
        ColumnFilter:           "Filter by column",
        ColumnFilterReset:      "Clean filter",
        ValueRemove:            "Remove value",
        ValueAdd:               "Add value",
        RowAddAfter:            "Add row after",
        RowRemove:              "Remove row",
        PropHistoryShow:        "Show property changes history",
        ChangesSaveAll:         "Save all changes in the row",
        EndpointsRequestError:  "Endpoints request error",
        ConsMandRequestErrors:  "Mandatory consolidations fields request error",
        ConsMandMsg:            "Mandatory for consolidation, must be filled",
        ClassesRequestError:    "Classes request error",
        InvalidDateFormat:      "Invalid date fromat",
        UseDateFormat:          "Use «yyyy-dd-mm»",
        UseDatetimeFormat:      "Use «yyyy-dd-mm hh:mm:ss»",
        InvalidFlagFormat:      "Invalid flag format",
        UseFlagFormat:          "Use «yes» or «no»",
        InvalidIntegerFormat:   "Invalid integer number format",
        UseIntegerFormat:       "Use digits and symbol \"-\" if necessary",
        InvalidDoubleFormat:    "Invalid float number format",
        UseDoubleFormat:        "Use digits and symbols \"-\" and \".\", if necessary",
        SchemaRequestError:     "Schema request error",
        newObject:              "object not yet created",
        ImportErrors:           "Import errors",
        importSucc:             "was imported successfully",
        importErr:              "import file error",
        SelectFile:             "Please select file",
        RefCantEmpty:           "Reference can't be empty",
        RefFillOrRemove:        "Fill it or remove field with it",
        MinFieldsFilled:        "This object required minimum filled fields of",
        FillMissingFields:      "Please fill missing fields",
        SavedObjectGetError:    "Error getting object after save",
        TotalObjects:           "Total objects",
        ObjectsViolated:        "Objects with violations",
        DataQuality:            "Data quality",
        DataQualityOWV:         "All violations",
        DataQualityALL:         "With and without violations",
        DataQualityShow:        "Show objects with the following violations:",
        OperationFinished:      "Operation has been finished",
        classMenu:              {
          items:      { constraints: "Apply constraints",                                                                 duplicates: "Apply duplicates search",                  references: "Refresh reference objects" },
          processing: { constraints: "Apply constraints is in progress...",                                            duplicates: "Duplicates search is in progress...",         references: "Reference objects refresh is in progress..." },
          finished:   { constraints: "Constraints have been applied.<br /><br /><b>Current page objects with violations: {count}</b>", duplicates: "Duplicates search has been finished.",  references: "Reference objects have been refreshed.<br /><br /><b>Created/updated: {count}</b>" },
          error:      { constraints: "Apply constraints error",                                                           duplicates: "Duplicate search error",                   references: "Reference objects refresh error" }
        },

        DuplicateFindingRules:      "Select a rule to run",
        DuplicateFindingRulesApply: "Run",
        DuplicateFindingRulesEmpty: "No rules have been defined.",

        ReferencesRefreshing:      "Refresh reference objects",
        ReferencesRefreshingApply: "Refresh",

        referencesRefreshingSetReferenceLink:  "set reference link",
        referencesRefreshingWriteProvenance:   "write provenance",

        columnFilters: {
          modeEqual:      "=\u00a0\u00a0equal",
          modeContains:   ".\u00a0\u00a0contain",
          modeLess:       "<\u00a0\u00a0less",
          modeLessEqual:  "<=\u00a0less or equal",
          modeMore:       ">\u00a0\u00a0more",
          modeMoreEqual:  ">=\u00a0more or equal",
          modeEmpty:      "\u2610\u00a0empty",
          modeEmptyNot:   "\u2611\u00a0not empty"
        },

        ConstraintsSearching:                 "Apply constraints",
        ConstraintsSearchingApply:            "Apply constraints",
        constraintsSearchingSortClassSelector:"Select sorting field",
        ConstraintsSearchingSpecifySort:      "Please select sorting field.",

        ClassMenu:          "Processing ",
        filtersSortsRemove: "click to remove all filters and sorting",

        XLSexportNoSort:    "Please sort the data by any column.",
        XLSimportLangWarn:  "The language selected is \"{lang}\".<br /><br />All imported data will be loaded with a language tag."
      },

      kz: {
        DataEditor:             "Деректер редакторы",
        Columns:                "Бағандар",
        ClassSelect:            "Сынып таңдаңыз",
        Choose:                 "Таңдау",
        ObjectAdd:              "Нысан құру",
        ObjectsMarkedDel:       "Таңдалған нысандарды жою",
        ImportXLSfile:          "Excel файлды импорттау",
        FileChoose:             "Файлды таңдаңыз",
        importXLSappend:        "бар қасиеттерге мәндер қосу",
        ImportXLSappendTip:     "Нысанның жаңа қасиеттерін сәйкестендіру және жасау үшін мәндерді қосу",
        importXLSreplace:       "барларының мәндерін ауыстырыңыз",
        ImportXLSreplaceTip:    "Барының мәндерін ауыстырыңыз және объектінің жаңа қасиеттерін жасаңыз",
        importXLSsubstitution:  "барлық қасиеттерді толық ауыстыру",
        ImportXLSsubstitutionTip:"Барлығын жойып, нысанның барлық жүктелген қасиеттерін жасаңыз",
        importXLSrulesApply:    "ережелерді қолдану",
        ValueRemove:            "Мәнді жою",
        ValueAdd:               "Мән қосу",
        RowAddAfter:            "Кейін жолды қосыңыз",
        RowRemove:              "Жолды жою",
        PropHistoryShow:        "Сипат өзгерістер тарихын көрсету",
        ChangesSaveAll:         "Осы жолдағы барлық өзгерістерді сақтаңыз",
        EndpointsRequestError:  "Соңғы нүктелерді сұрау қатесі",
        ConsMandRequestErrors:  "Міндетті біріктіру өрістері қатені сұрайды",
        ConsMandMsg:            "Біріктіру үшін міндетті, толтырылуы керек",
        ClassesRequestError:    "Сыныптар сұрау қатесі",
        InvalidDateFormat:      "Күн пішімі жарамсыз",
        UseDateFormat:          "«кк.аа.жжжж» пайдаланыңыз",
        UseDatetimeFormat:      "«кк.аа.жжжж сс:мм:сс» пайдаланыңыз",
        InvalidFlagFormat:      "Жарамсыз жалау пішімі",
        UseFlagFormat:          "Иә немесе жоқ пайдаланыңыз",
        InvalidIntegerFormat:   "Жарамсыз бүтін сан пішімі",
        UseIntegerFormat:       "Қажет болса, сандар мен «-» таңбасын пайдаланыңыз",
        InvalidDoubleFormat:    "Қалқымалы сан пішімі жарамсыз",
        UseDoubleFormat:        "Қажет болса, «-» және «.» сандары мен таңбаларын пайдаланыңыз",
        SchemaRequestError:     "Схеманы алу қатесі",
        newObject:              "әлі жасалмаған нысан",
        ImportErrors:           "Импорттау қателері",
        importSucc:             "сәтті импортталды",
        importErr:              "файлды импорттау қатесі",
        SelectFile:             "Сіз файлды таңдауыңыз керек",
        RefCantEmpty:           "Көрсеткіш бос болуы мүмкін емес",
        RefFillOrRemove:        "Оны толтырыңыз немесе онымен өрісті жойыңыз",
        MinFieldsFilled:        "Осы нысан үшін толтырылған өрістердің ең аз саны",
        FillMissingFields:      "Жетіспейтін өрістерді толтырыңыз",
        SavedObjectGetError:    "Сақтаудан кейін нысанды алу қатесі",
        TotalObjects:           "Жалпы объектілер",
        ObjectsViolated:        "Бұзушылықтары бар объектілер",
        DataQuality:            "Деректер сапасы",
        DataQualityOWV:         "Барлық бұзушылықтар",
        DataQualityALL:         "Бұзушылықпен және бұзушылықсыз",
        DataQualityShow:        "Тек бұзушылықтары бар нысандарды көрсетуді өшіріңіз",
        OperationFinished:      "Операция аяқталды",
        classMenu:              {
          items:      { constraints: "Шектеулерді қолдану",                                                duplicates: "Көшірмелерді іздеуді қолданыңыз", references: "Анықтамалық нысандарды жаңарту" },
          processing: { constraints: "Шектеулер қолданылуда...",                                           duplicates: "Көшірмелерді іздеу орындалуда...",references: "Анықтамалық нысандарды жаңарту орындалуда..." },
          finished:   { constraints: "Шектеулер қолданылды.<br /><br /><b>Бұзушылықтары бар ағымдағы бет нысандары: {count}</b>", duplicates: "Көшірмелерді іздеу аяқталды.",    references: "Сілтеме нысандары жаңартылды.<br /><br /><b>Жасалған/жаңартылған: {count}</b>" },
          error:      { constraints: "Қатені қолдану шектеулері",                                          duplicates: "Қайталанатын іздеу қатесі",       references: "Анықтамалық нысандарды жаңарту қатесі" }
        },

        DuplicateFindingRules:      "Көшірмелерді іздеу ережесін таңдау",
        DuplicateFindingRulesApply: "Іздеу",
        DuplicateFindingRulesEmpty: "Ешқандай ережелер анықталған жоқ.",

        ReferencesRefreshing:      "Анықтамалық нысандарды жаңарту",
        ReferencesRefreshingApply: "Жаңарту",

        referencesRefreshingSetReferenceLink:  "сілтеме сілтемесін орнату",
        referencesRefreshingWriteProvenance:   "шығу тегін жаз",

        columnFilters: {
          modeEqual:      "=\u00a0\u00a0тең",
          modeContains:   ".\u00a0\u00a0қамтиды",
          modeLess:       "<\u00a0\u00a0аздау",
          modeLessEqual:  "<=\u00a0аз немесе тең",
          modeMore:       ">\u00a0\u00a0көбірек",
          modeMoreEqual:  ">=\u00a0артық немесе тең",
          modeEmpty:      "\u2610\u00a0empty",
          modeEmptyNot:   "\u2611\u00a0not empty"
        },

        ConstraintsSearching:                 "Қолданылатын шектеулер",
        ConstraintsSearchingApply:            "Шектеулерді қолдану",
        constraintsSearchingSortClassSelector:"Сұрыптау өрісін таңдаңыз",
        ConstraintsSearchingSpecifySort:      "Сұрыптау өрісін таңдаңыз.",

        ClassMenu:          "Өңдеу... ",
        filtersSortsRemove: "барлық сүзгілерді және сұрыптауды жою үшін басыңыз",
        XLSexportNoSort:    "Деректерді кез келген баған бойынша сұрыптаңыз.",
        XLSimportLangWarn:  "\"{lang}\" тілі таңдалды. Барлық импортталған деректер тіл тегімен жүктеледі."
      }
    }
  },

  idShow: true,

  columnsDefHidden: [
    "http://www.w3.org/2000/01/rdf-schema#comment",
    "http://datavera.kz/ekg/archive",
    "http://www.w3.org/2002/07/owl#sameAs",
    "http://datavera.kz/ekg/inferredBy",
    "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
    "http://www.w3.org/2000/01/rdf-schema#isDefinedBy"
  ],

  ovls: {
    utils,
    dates
  },

  data() {
    return {
      loading: true,
      loadingStop: null,

      page: 1,
      pages: 1,

      columns: null,

      rows: [
      ],

      classId: null,

      endpoints: null,

      endpointId: null,

      editing: {
      },
      editingZ: 10,

      modals: [],

      XLSimportShow: false,
      XLSimportData: null,
      XLSimportMode: "replace",
      XLSimportError: null,

      quality:  {
        tip:    false,
        active: null,

        total:        null,
        incorrect:    null,
        violations:   null,
        validPercent: null,

        shapes:       []
      },

      classMenuS: null,
      classMenuProcessingPercentage: null,

      duplicateFindingRulesShow:    false,
      duplicateFindingRules:        null,
      duplicateFindingRuleSelected: null,

      referencesRefreshingShow:            false,
      referencesRefreshingSetReferenceLink:true,
      referencesRefreshingWriteProvenance: true,

      constraintsSearchingShow: false,
      constraintsSearchingSortClass: { id: null, name: null },
      constraintsSearchingError: null,

      filtersSortsAppliedShow: false,

      violations: {},

      consMand: null,

      schedulerShow:          false,
      schedulerXLSimportShow: false,
      schedulerXLSimportData: null,
      schedulerXLSimportMode: "replace",
      schedulerXLSimportError: null,
      schedulerApplyRules: false,

      rowsCount: null
    }
  },
  async created() {
    //this.$root.pageTitle = "DataVera EKG Explorer";
  },
  updated() {
    this.onResize();
  },
  mounted() {
    let endpointId, classId;

    if ( this.$route ) {
//      if ( this.$route.params.endpoint && this.$route.params.cls ) {
      if ( this.$route.params.endpoint && this.$route.params.classId ) {
        endpointId = this.$route.params.endpoint;
        classId = this.$route.params.classId;
      }
    }

    this.reload( endpointId, classId );
  },
  beforeUnmount() {
    this.$options.ro.unobserve( this.$refs.main.$el.querySelector( ".table" ) );
  },

  watch:{
    endpointId: {
      handler( nv, ov ) {
        ls.set( "EndpointId", nv, "editorView" );
      }
    },
/*
    classId: {
      handler( nv, ov ) {
        this.rowsCount = null;

        let ds = ls.get( "Endpoint_" + this.endpointId, "editorView" );
        if ( !ds ) ds = {};
        ds.classId = nv;
        ls.set( "Endpoint_" + this.endpointId, ds, "editorView" );

        if ( nv != ov ) {
          const p = `/editor/${encodeURIComponent( this.endpointId )}/${encodeURIComponent( nv )}`;
          const op = this.$route.path.replace( /:/g, "%3A" );
          if ( op.indexOf( p ) !== 0 ) this.$router.push( p ).catch( () => {} );
        }
      }
    },
*/
    classId: {
      handler() {
        let ds = ls.get( "Endpoint_" + this.endpointId, "editorView" );
        if ( !ds ) ds = {};
        ds.classId = this.classId;
        ls.set( "Endpoint_" + this.endpointId, ds, "editorView" );
      }
    },

    endpointAndClass: {
      immediate: true,
      handler() {
        this.rowsCount = null;

        if ( this.endpointId && this.classId ) {
          const p = `/editor/${encodeURIComponent( this.endpointId )}/${encodeURIComponent( this.classId )}`;
          const op = this.$route.path.replace( /:/g, "%3A" );
          if ( op.indexOf( p ) !== 0 ) this.$router.push( p ).catch( () => {} );

          console.log( p );
        }
      }
    },

    "quality.active"() {
      this.tableUpdate();
    }
  },

  methods: {
    qualityPageOpen() {
      window.open( `/quality/${encodeURIComponent( this.endpointId )}/${encodeURIComponent( this.classId )}`, "_blank").focus();
    },

    async schedulerOpen() {
      this.schedulerShow = true;
    },

    modalOpen( content, ok, title, cancel, labelOk, labelCancel ) {
      const modal = {
        id: utils.uniqueHashGen(),
        content,
        title:  title || null,
        show:   false,
        ok,
        cancel,
        labelOk,
        labelCancel
      };

      this.modals.push( modal );

      this.$nextTick( () => { this.$set( modal, "show", true ); } );
    },
    modalEvent( e, modalId ) {
      const modal = this.modals.find( i => i.id === modalId );
      if ( !modal ) return;

      modal.show = false;

      switch ( e ) {
        case "ok":
          if ( modal.ok ) modal.ok();
        break;

        case "close":
        case "cancel":
          if ( modal.cancel ) modal.cancel();
        break;
      }
    },
    modalRemove( modalId ) {
      const modalI = this.modals.findIndex( i => i.id === modalId );
      if ( modalI >= 0 ) {
        this.modals.splice( modalI, 1 );
      }
    },

    /*
      dirty hack to disable tableUpdate
      must be replaced for watcher on "columns + page" => rowsRequest
    */
    tableUpdateEnable( state ) {
      if ( state ) {
        if ( this.$options.tableUpdate ) {
          this.tableUpdate = this.$options.tableUpdate;
          this.$options.tableUpdate = null;
        }
      }
      else {
        if ( !this.$options.tableUpdate ) {
          this.$options.tableUpdate = this.tableUpdate;
          this.tableUpdate = async () => {};
        }
      }
    },

    async reload( endpointId, classId ) {
      if ( classId && classId.id ) classId = classId.id;
      if ( endpointId && endpointId.id ) endpointId = endpointId.id;
const debugTree = endpointId === undefined ? classId : null;
if ( debugTree ) console.log( "!!!", debugTree );
      this.tableUpdateEnable( false );

      this.columns = {};
      this.rows = [];

      this.classMenuProcessingPercentage = null;
      this.classMenuS = null;
      this.constraintsSearchingSortClass = { id: null, name: null };

      this.loading = true;
      this.editing = {};
      this.page = 1;
      this.pages = 1;
/*
try {
  const ans = await this.$options.api.post.json(
    "/test",
    this.apiQueryStd
  );
}
catch ( e ) {
  console.error( e );
}
/**/
      if ( !this.endpoints ) {
if ( debugTree ) console.log( "!!!", "endpoints are empty" );
        let endpoints = {};

        try {
          const ans = await this.$options.api.post.json(
            "/endpoints",
              {
                ...this.apiQueryStd,
                lang: this.langInterf
              }
          );

          if ( !ans ) throw new Error( "malformed server answer" );
          if ( ans.error ) throw new Error( ans.error );
          if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );
          if ( !( "items" in ans ) ) throw new Error( this.$t( "InvalidServerAnswer" ) + ": " + JSON.encode( ans ) );

          endpoints = ans.items;
        }
        catch ( e ) {
          console.error( "ENDPOINTS REQUEST ERROR: request items is failed with " + e.message, e.stack );
          this.$root.$emit( "notify", { header: this.$t( 'EndpointsRequestError' ), message: e.message, type: "error" } );
        }

        this.endpoints = endpoints;
if ( debugTree ) console.log( "!!!", "endpoints requested", endpoints );
      }

      if ( endpointId === undefined ) {
        if ( this.endpointId === null ) {
          const eps = ls.get( "EndpointId", "editorView" );
          if ( eps ) endpointId = eps;
        }
        else endpointId = this.endpointId;
      }
if ( debugTree ) console.log( "!!!", "endpoint selected is", endpointId );
      if ( !( endpointId in this.endpoints ) ) endpointId = utils.objGetFirstKey( this.endpoints );
if ( debugTree ) console.log( "!!!", "endpoint in use is", endpointId );

      this.endpointId = endpointId;

      if ( this.endpointId ) {
        if ( !this.$options.endpointsClasses ) this.$options.endpointsClasses = {};

        let endpointClasses;
        if ( this.endpointId in this.$options.endpointsClasses ) endpointClasses = this.$options.endpointsClasses[ this.endpointId ];
        else {
          try {
            const ans = await this.$options.api.post.json(
              "/classes",
                {
                  ...this.apiQueryStd,
                  lang: this.langInterf
                }
            );

            if ( !ans ) throw new Error( "malformed server answer" );
            if ( ans.error ) throw new Error( ans.error );
            if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );
            if ( !( "items" in ans ) ) throw new Error( this.$t( "InvalidServerAnswer" ) + ": " + JSON.encode( ans ) );

            endpointClasses = ans.items;
            //remove standard classes (they are always in the root folder)
            for ( const id in endpointClasses ) {
                if (
                  endpointClasses.hasOwnProperty( id ) &&
                  id.indexOf( "http://www.w3.org/" ) == 0 &&
                  ( !this.$options.attrsStdInclude || this.$options.attrsStdInclude.findIndex( i => id.includes( i ) ) == -1 )
                ) delete endpointClasses[ id ];
            }
          }
          catch ( e ) {
            endpointClasses = {};
            console.error( "CLASSES REQUEST ERROR: request items is failed with " + e.message, e.stack );
            this.$root.$emit( "notify", { header: this.$t( "ClassesRequestError" ), message: e.message, type: "error" } );
          }

          this.$options.endpointsClasses[ this.endpointId ] = endpointClasses;
        }

        if ( !classId ) {
if ( debugTree ) console.log( "!!!", "class is empty" );
          const ds = ls.get( "Endpoint_" + this.endpointId, "editorView" );
          if ( ds ) classId = ds.classId;
        }

        if ( classId && !( classId in endpointClasses ) ) classId = null;
if ( debugTree ) console.log( "!!!", "class now is", classId );

        if ( !classId ) {
if ( debugTree ) console.log( "!!!", "class still is empty", classId );
          //trying to find something without any prefixes
          for ( const id in endpointClasses ) {
              if ( endpointClasses.hasOwnProperty( id ) && id.indexOf( "http://" ) != 0 ) classId = id;
          }

          //if not found - use first class
          if ( !classId ) classId = utils.objGetFirstKey( endpointClasses );
        }

if ( debugTree ) console.log( "!!!", "class in use is", classId );
        this.classId = classId;

        await this.tableGetColumns();

if ( debugTree ) console.log( "!!!", "totally endpoint is", this.endpointId, "class is", this.classId );
        const ds = this.storageClassDataGet( this.endpointId, this.classId );
        if ( ds && ds.page ) this.page = ds.page;

        await this.$nextTick();
        this.tableUpdateEnable( true );

        await this.consMandGet();

        await this.tableUpdate();

        //no await is necessary
        //noinspection ES6MissingAwait
        this.qualityRequest();

        this.loading = false;
      }

      this.loading = false;

      if ( this.$refs.main ) {
        if ( !this.$options.ro ) {
          this.$options.ro =  new ResizeObserver(
              () => {
                this.onResize();
              }
          );
          this.$options.ro.observe( this.$refs.main.$el.querySelector( ".table" ) );
        }
      }
    },

    async reloadTable() {
      this.editing = {};
      await this.tableUpdate();
    },

    endpointClassesGet( classId ) {
      if (
        this.$options.endpointsClasses &&
        ( this.endpointId in this.$options.endpointsClasses )
      ) {
        if ( classId in this.$options.endpointsClasses[ this.endpointId ] ) return this.$options.endpointsClasses[ this.endpointId ][ classId ];
      }
      return {
        id:   classId,
        name: " "
      };
    },

    async onResize( h ) {
      if ( !this.$refs.main ) return;

      const tc = this.$refs.main.$el.getBoundingClientRect();
      const tcr = tc.right + window.scrollX;

      for ( const rid in this.editing ) {
        if ( this.editing.hasOwnProperty( rid ) ) {
          const row = this.editing[ rid ];
          for ( const cid in row ) {
            if ( row.hasOwnProperty( cid ) ) {
              const data = row[ cid ];
              if ( data && data.show && data.el ) {
                this.$set( data, "anglePosition", "start" );
                this.$set( data, "class", "" );

                await this.$nextTick();

                let ec = data.el.querySelector( ".fields" );
                if ( ec ) {
                  ec = ec.getBoundingClientRect();
                  const ecr = ec.right + window.scrollX;

                  if ( ecr > tcr ) {
                    this.$set( data, "anglePosition", "end" );
                    this.$set( data, "class", "inverted" );
                  }
                }
                else return;
              }
            }
          }
        }
      }

      if ( h ) h();
    },

    filtersValidate( type, colId, v ) {
      if ( type == "filtersColumns" ) {
        v = v.trim();

        switch( ( "" + this.columnGetType( colId ) ).toLowerCase() ) {
          case "xsd:date":
          case "http://www.w3.org/2001/xmlschema#date":
            if ( v ) {
              if ( this.langInterf == "en" ) {
                if ( !dates.check( v, dates.types.ENG ) ) return "<b>" + this.$t( 'InvalidDateFormat' ) + ".</b><br /><br />" + this.$t( 'UseDateFormat' );
              }
              else {
                if ( !dates.check( v, dates.types.RUS4Y ) ) return "<b>" + this.$t( 'InvalidDateFormat' ) + ".</b><br /><br />" + this.$t( 'UseDateFormat' );
              }
            }
          break;

          case "xsd:datetime":
          case "http://www.w3.org/2001/xmlschema#datetime":
            if ( v ) {
              if ( this.langInterf == "en" ) {
                if ( !dates.check( v, dates.types.ENG, true ) ) return "<b>" + this.$t( 'InvalidDateFormat' ) + ".</b><br /><br />" + this.$t( 'UseDatetimeFormat' );
              }
              else {
                if ( !dates.check( v, dates.types.RUS4Y, true ) ) return "<b>" + this.$t( 'InvalidDateFormat' ) + ".</b><br /><br />" + this.$t( 'UseDatetimeFormat' );
              }
            }
          break;

          case "xsd:boolean":
          case "http://www.w3.org/2001/xmlschema#boolean":
            v = v.toLowerCase();
            if ( v && v != this.$t( 'yes' ) && v!= this.$t( 'no' ) ) return "<b>" + this.$t( 'InvalidFlagFormat' ) + ".</b><br /><br />" + this.$t( 'UseFlagFormat' );
          break;

          case "xsd:integer":
          case "http://www.w3.org/2001/xmlschema#integer":
            if ( v && !/^[+-]?\d+$/.test( v ) ) return "<b>" + this.$t( 'InvalidIntegerFormat' ) + ".</b><br /><br />" + this.$t( 'UseIntegerFormat' );
          break;

          case "xsd:double":
          case "http://www.w3.org/2001/xmlschema#double":
            if ( v && !/^[+-]?(?:\d+\.)?\d+$/.test( v ) ) return "<b>" + this.$t( 'InvalidDoubleFormat' ) + ".</b><br /><br />" + this.$t( 'UseDoubleFormat' );
          break;
        }
      }

      return null;
    },

    editingValConvert( cid, v, toDataProvider ) {
      const type = this.columnGetType( cid ).toLowerCase();

      if ( v && typeof( v ) == "object" && type !== "reference" ) v = v.value;

      switch ( type ) {
        case "xsd:boolean":
        case "http://www.w3.org/2001/xmlschema#boolean":
          v = v === "true" || v === true || v === 1 || v === "1";
        break;

        case "xsd:date":
        case "http://www.w3.org/2001/xmlschema#date":
          if ( v ) {
            let fr, to, re;

            if ( toDataProvider ) {
              fr = dates.types.RUS4Y;
              to = dates.types.ISO;
              re = /^\s*\d{2}\.\d{2}\.\d{4}\s*$/;
            }
            else {
              fr = dates.types.ISO;
              to = dates.types.RUS4Y;
              re = /^\s*\d{4}-\d{2}-\d{2}\s*$/;
            }

            if ( re.test( v ) ) {
              try {
                const s = dates.parse( v, fr );
                if ( s && s.day !== undefined && s.month !== undefined && s.year !== undefined ) {
                  v = dates.format( s, dates.types.STRUCT, to, false, true );
                }
              }
              catch ( e ) {}
            }
          }
          else v = "";
        break;

        case "xsd:datetime":
        case "http://www.w3.org/2001/xmlschema#datetime":
          if ( v ) {
            let fr, to, re;
            if ( toDataProvider ) {
              fr = dates.types.RUS4Y;
              to = dates.types.ISO;
              re = /^\s*\d{2}\.\d{2}\.\d{2} \d{2}:\d{2}:\d{2}\s*$/;
            }
            else {
              fr = dates.types.ISO;
              to = dates.types.RUS4Y;
              re = /^\s*\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\s*$/;
            }

            if ( re.test( v ) ) {
              try {
                const s = dates.parse( v, fr );
                if (
                    s &&
                    s.day !== undefined && s.month !== undefined && s.year !== undefined &&
                    s.hours !== undefined && s.minutes !== undefined && s.seconds !== undefined
                ) {
                  v = dates.format( s, dates.types.STRUCT, to, true, true );
                }
              }
              catch ( e ) {}
            }
          }
          else v = "";
        break;
      }

      return v;
    },

    editingValGet( rowId, colId, vi ) {
      let v = this.editingData( rowId, colId ).values[ vi ];
      if ( this.columnGetType( colId ).toLowerCase() != "reference" ) v = v.value;

      return this.editingValConvert( colId, v );
    },

    editingValSet( rowId, colId, vi, v ) {
      const vc = this.editingData( rowId, colId ).values[ vi ];
      if ( this.columnGetType( colId ).toLowerCase() == "reference" ) this.$set( this.editingData( rowId, colId ).values, vi, { ...vc, ...this.editingValConvert( colId, v, true ) } );
      else this.$set( this.editingData( rowId, colId ).values[ vi ], "value", this.editingValConvert( colId, v, true ) );
    },

    async tableGetColumns() {
      let ans;
      if ( !this.classId ) {
        ans = {
          item: {
            attrs: {}
          },
          errors: []
        };
      }
      else {
        ans = await this.$options.api.post.json(
          "/editing/entitySchema",
          {
            ...this.apiQueryStd,
            id: this.classId,
            lang: this.langInterf
          }
        );
      }

      let columns = {
      };

      try {
        if ( ans && ( "item" in ans ) ) {
          if ( ans.errors.length ) {
            this.$root.$emit( "notify", { header: this.$t( "SchemaRequestError" ), message: ans.errors.join( "<br />" ), type: "error" } );
          }

          if ( ans.item ) {
            for ( const aid in ans.item.attrs ) {
              if ( ans.item.attrs.hasOwnProperty( aid ) ) {
                const attr = ans.item.attrs[ aid ];
                if ( attr.archive == true ) continue;

                let filter;
                switch ( ( "" + attr.type ).toLowerCase() ) {
                  case "http://www.w3.org/2001/xmlschema#string":
                    filter = {
                      value: "",
                      mode: "equal",
                      modes: {
                        equal: {
                          name: this.$t( "columnFilters" ).modeEqual,
                          icon: "fEqual"
                        },
                        contains: {
                          name: this.$t( "columnFilters" ).modeContains,
                          icon: "fContains"
                        },
                        notexists: {
                          name: this.$t( "columnFilters" ).modeEmpty,
                          icon: "fEmpty"
                        },
                        exists: {
                          name: this.$t( "columnFilters" ).modeEmptyNot,
                          icon: "fEmptyNot"
                        }
                      }
                    };
                  break;

                  case "http://www.w3.org/2001/xmlschema#date":
                  case "http://www.w3.org/2001/xmlschema#datetime":
                  case "http://www.w3.org/2001/xmlschema#integer":
                  case "http://www.w3.org/2001/xmlschema#double":
                    filter = {
                      value: "",
                      mode: "equal",
                      modes: {
                        equal: {
                          name: this.$t( "columnFilters" ).modeEqual,
                          icon: "fEqual"
                        },
                        less: {
                          name: this.$t( "columnFilters" ).modeLess,
                          icon: "fLess"
                        },
                        lessOrEqual: {
                          name: this.$t( "columnFilters" ).modeLessEqual,
                          icon: "fLessEqual"
                        },
                        more: {
                          name: this.$t( "columnFilters" ).modeMore,
                          icon: "fMore"
                        },
                        moreOrEqual: {
                          name: this.$t( "columnFilters" ).modeMoreEqual,
                          icon: "fMoreEqual"
                        },
                        notexists: {
                          name: this.$t( "columnFilters" ).modeEmpty,
                          icon: "fEmpty",
                          valueDisable: false
                        },
                        exists: {
                          name: this.$t( "columnFilters" ).modeEmptyNot,
                          icon: "fEmptyNot",
                          valueDisable: false
                        }
                      }
                    };
                  break;

                  case "reference":
                    filter = {
                      value: "",
                      mode: "equal",
                      modes: {
                        equal: {
                          name: this.$t( "columnFilters" ).modeEqual,
                          icon: "fEqual"
                        },
                        contains: {
                          name: this.$t( "columnFilters" ).modeContains,
                          icon: "fContains"
                        },
                        notexists: {
                          name: this.$t( "columnFilters" ).modeEmpty,
                          icon: "fEmpty",
                          valueDisable: false
                        },
                        exists: {
                          name: this.$t( "columnFilters" ).modeEmptyNot,
                          icon: "fEmptyNot",
                          valueDisable: false
                        }
                      }
                    };
                  break;

                  default:
                    filter = "";
                }

                columns[ attr.id ] = {
                  ...attr,
                  name:   attr.name,
                  show:   true,
                  sort:   "",
                  move:   true,
                  filter
                }
              }
            }
          }
        }
        else throw new Error( "invalid answer" );
      }
      catch ( e ) {
        this.$root.$emit( "notify", { header: this.$t( "Error" ), message: e.message, type: "error" } );
      }

      const ds = ls.get( "Endpoint_" + this.endpointId, "editorView" );
      if ( ds && ds.classes && ( this.classId in ds.classes ) && ds.classes[ this.classId ].columns ) {
        const columnsS = ds.classes[ this.classId ].columns;

        const t = columns;
        columns = {};
        for ( const cid in columnsS ) {
          if ( columnsS.hasOwnProperty( cid ) && cid.charAt( 0 ) != '&' ) {
            if ( t.hasOwnProperty( cid ) ) {

              //use only filter value and mode from stored columns
              let filter = t[ cid ].filter;
              let filterValueS = columnsS[ cid ].filter;
              let filterModeS = null;
              if ( utils.objIs( filterValueS ) ) {
                filterModeS = filterValueS.mode;
                filterValueS = filterValueS.value;
              }
              if ( utils.objIs( filter ) ) {
                filter.value = filterValueS;
                if ( filterModeS ) filter.mode = filterModeS;
              }
              else filter = filterValueS;

              columns[ cid ] = {
                ...t[ cid ],
                ...columnsS[ cid ],
                filter,
                //always get column name from requested columns
                name: t[ cid ].name
              };
            }
          }
        }
        for ( const cid in t ) {
          if ( t.hasOwnProperty( cid ) && cid.charAt( 0 ) != '&' ) {
            if ( t.hasOwnProperty( cid ) && !( cid in columns ) ) {
              columns[ cid ] = t[ cid ];
            }
          }
        }
      }
      else {
        //нет выставленных пользователем столбцов, убрать некоторые столбцы по-умолчанию
        for ( const cid of this.$options.columnsDefHidden ) {
          if ( cid in columns ) columns[ cid ].show = false;
        }
      }

      columns = Object.assign(
        {
          "&selection": {
            name: "",
            show:   true,
            sort:   false,
            filter: false,
            move:   false,
            implicit: true,
            marked:  "selection dblClkIgnore"
          },
          "&controls": {
            name: "",
            show:   true,
            sort:   false,
            filter: false,
            move:   false,
            implicit: true,
            marked:  "controls dblClkIgnore"
          },
          ... this.$options.idShow && {
            "&id": {
              name: "",
              type:   "",
              show:   true,
              sort:   false,
              filter: "",
              move:   false,
              implicit: true,
              marked: "__id__"
//              marked:  "dblClkIgnore"
            }
          }
        },

        columns
      );

      this.columns = utils.objIsEmpty( columns ) ? null : columns;
    },

    valuesAsText( values, colType, valueType ) {
        let valAsText;

        if ( valueType == "own" ) values = values.filter( i => !i.inferred );
        else if ( valueType == "inferred" ) values = values.filter( i => i.inferred );

        switch ( ( "" + colType ).toLowerCase() ) {
          case "reference":
            valAsText = values.reduce( ( a, i ) => { a += ( a ? ", " : "" ) + ( i.name ? i.name : i.id ); return a; }, "" );
          break;

          case "xsd:boolean":
          case "http://www.w3.org/2001/xmlschema#boolean":
            valAsText = values.reduce( ( a, i ) => { i = "" + i.value; a += ( a ? ", " : "" ) + ( i === true || i === "true" || i === 1 || i === "1" ? this.$t( "Yes" ) : ( i === false || i === "false" ? this.$t( "No" ) : "" ) ); return a; }, "" );
          break;

          case "xsd:date":
          case "http://www.w3.org/2001/xmlschema#date":
            valAsText = values.reduce( ( a, i ) => { i = "" + i.value; a += ( a ? ", " : "" ) + ( i ? dates.format( i, dates.types.ISO, this.dateType, false, true ) : "" ); return a; }, "" );
          break;

          case "xsd:datetime":
          case "http://www.w3.org/2001/xmlschema#datetime":
            valAsText = values.reduce( ( a, i ) => { i = "" + i.value; a += ( a ? ", " : "" ) + ( i ? dates.format( i, dates.types.ISO, this.dateType, true, true ) : "" ); return a; }, "" );
          break;

          default:
            valAsText = values.reduce( ( a, i ) => { a += ( a ? ", " : "" ) + i.value; return a; }, "" );
        }

        return valAsText;
    },

    rowGetAsHTML( row ) {
      const rowValues = row.values;
      let html = '<table cellspacing="0" cellpadding="0" border="0" class="tableObjProps"><caption></caption><tr><th scope="col">' + this.$t( "Property" ) + '</th><th scope="col">' + this.$t( "Value" ) + '</th></tr>';
      if ( row.new ) html += '<tr><th scope="row">' + this.$t( "URI" ) + '</th><td>' + this.$t( "newObject" ) + '</td></tr>';
      else html += '<tr><th scope="row">' + this.$t( "URI" ) + '</th><td>' + row.id + '</td></tr>';

      for ( const colId in rowValues ) {
        if ( rowValues.hasOwnProperty( colId ) && ( colId in this.columns ) ) {
          const col = this.columns[ colId ];
          const values = rowValues[ colId ];
          if ( values.length ) html += '<tr><th col="row">' + col.name + '</th><td>' + this.valuesAsText( values, col.type ) + '</td></tr>';
        }
      }

      html += '</table>'

      return html;
    },

    rowFromItem( item ) {
      if ( !item || item.archive == true ) return null;

      const row = {
        ...item,
        values:   {},
        columns:  {}
      };

      for ( const colId in this.columns ) {
        if ( this.columns.hasOwnProperty( colId ) ) {
          const col = this.columns[ colId ];
          const colType = this.columnGetType( colId );

          const values = item.attrs && ( colId in item.attrs ) ? item.attrs[ colId ].values : [];
//!!!
/*
  if ( colType == "http://www.w3.org/2001/XMLSchema#string" ) values.push( { lang: null, inferred: "http://test.com/...", value: "aaa" } );
/**/
          row.values[ colId ] = values;
          row.columns[ colId ] = {
            own:   this.valuesAsText( values, colType, "own" ),
            inferred: this.valuesAsText( values, colType, "inferred" )
          }
        }
      }

      return row;
    },

    rowsRequestParams( page ) {
      const filters = {};
      const sort = {};
      for ( const colId in this.columns ) {
        if ( this.columns.hasOwnProperty( colId ) ) {
          const col = this.columns[ colId ];
          if ( !col.show ) continue;

          if ( col.filter ) {
            const fo = utils.objIs( col.filter );
            let fv = fo ? col.filter.value : col.filter;
            if ( fv ) {
              fv = frontbackUtils.valueFrontToBack( fv, this.columnGetType( colId ).toLowerCase(), this.langInterf );
              filters[ colId ] = fo ? { values: fv, comparison: col.filter.mode } : fv;
            }
          }

          if ( col.sort ) {
            sort.id = colId;
            sort.type = col.sort;
          }
        }
      }

      return {
        ...this.apiQueryStd,
        classes:      this.classId,
        page,
        filters,
        sort,
        violations:   this.quality.active
      };
    },

    async rowsRecount() {
      this.rowsCount = "";

      try {
        const ans = await this.$options.api.post.json(
          "/editing",
            { ...this.rowsRequestParams( 1 ), count: true }
        );

        let pages, items;
        if ( ans && "pages" in ans && "items" in ans ) {
          pages = ans.pages;
          items = ans.items;
        }
        else {
          pages = "?";
          items = "?";
        }

        this.rowsCount = `${ pages } <span style="font-weight: normal; font-size: 0.9em;">(${ items })</span>`;
      }
      catch ( e ) {
        console.error( e );
        throw e;
      }
    },

    async rowsRequest( page ) {
      if ( this.$options.rowsRequestAbort ) this.$options.rowsRequestAbort.abort();
      this.$options.rowsRequestAbort = new AbortController();
      this.loadingStop = () => {
        if ( this.$options.rowsRequestAbort ) this.$options.rowsRequestAbort.abort();
      };

      try {
        const ans = await this.$options.api.post.json(
          "/editing",
          this.rowsRequestParams( page ),
          {
            signal: this.$options.rowsRequestAbort.signal
          }
        );

        const rows = [];
        let pageA = null, pagesA = null;

        try {
          if ( ans && ( "items" in ans ) ) {
            if ( ans.errors.length ) {
              this.$root.$emit( "notify", { header: this.$t( "DataRequestError" ), message: ans.errors.join( "<br />" ), type: "error" } );
            }

            if ( ans.items ) {
              for ( const oid in ans.items ) {
                if ( ans.items.hasOwnProperty( oid ) ) {
                  const item = ans.items[ oid ];

                  const row = this.rowFromItem( item );
                  if ( row ) rows.push( row );
                }
              }
            }

            pageA = "page" in ans ? ans.page : null;
            pagesA = "pages" in ans ? ans.pages : null;
          }
          else throw new Error( "invalid answer" );
        }
        catch ( e ) {
          this.$root.$emit( "notify", { header: this.$t( "Error" ), message: e.message, type: "error" } );
        }




        //violations
        const vss = rows.length ? await this.violationsGet( rows.map( i => i.id ), this.$options.rowsRequestAbort ) : [];
        for ( const row of rows ) {
          row.violations = row.id in vss ? vss[ row.id ] : null;
        }

        this.$options.rowsRequestAbort = null;
        this.loadingStop = null;

        return {
          rows,
          page: pageA,
          pages:pagesA
        }
      }
      catch ( e ) {
        console.error( e );

        //if request has been aborted
        if ( e.isAborted ) return {
          rows:   [],
          page:   1,
          pages:  1,
        };

        else throw e;
      }
    },

    async violationsGet( ids, abortController ) {
      const items = {};

      try {
        const res = await this.$options.api.post.json(
          "/violations/attributes",
          {
            ...this.apiQueryStd,
            id: ids,
            ...abortController && { signal: abortController.signal }
          }
        );

        if ( res && res.items ) {
          for ( const id in res.items ) {
            if ( res.items.hasOwnProperty( id ) ) {
              const shapesForItem = res.items[ id ];

              const attrs = {};
              for ( const s of shapesForItem ) {
                if ( s.attrs ) {
                  for ( const a of s.attrs ) {
                    if ( !( a in attrs ) ) attrs[ a ] = {};
                    if ( !( "msg" in attrs[ a ] ) ) attrs[ a ].msg = "";
                    attrs[ a ].msg += ( attrs[ a ].msg ? "; " : "" ) + s.msg;
                    if ( !( "severity" in attrs[ a ] ) || this.$options.severities[ s.severity ] < this.$options.severities[ attrs[ a ].severity ] ) attrs[ a ].severity = s.severity;
                  }
                }
              }

              if ( !utils.objIsEmpty( attrs ) ) items[ id ] =  attrs;
            }
          }
        }
      }
      catch ( e ) {
        console.error( e );
      }

      return items;
    },

    async consMandGet() {
      try {
        const ans = await this.$options.api.post.json(
          "/consolidation/attributes",
            {
              ...this.apiQueryStd,
              lang: this.langInterf,
              id: this.classId
            }
        );

        if ( !ans ) throw new Error( "malformed server answer" );
        if ( ans.error ) throw new Error( ans.error );
        if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );
        if ( !( "items" in ans ) ) throw new Error( this.$t( "InvalidServerAnswer" ) + ": " + JSON.encode( ans ) );

        this.consMand = new Set();
        for ( const i of ans.items ) {
          if ( i.mandatory ) this.consMand.add( i.id );
        }
      }
      catch ( e ) {
        console.error( "CONSOLIDATIONS MANDATORY ATTRIBUTES REQUEST ERROR: request items is failed with " + e.message, e.stack );
        this.$root.$emit( "notify", { header: this.$t( 'ConsMandRequestError' ), message: e.message, type: "error" } );
      }
    },

    consMandWarn( row, col ) {
      if ( !row || !col || !this.consMand ) return false;

      if (
        !this.consMand.has( col.id ) ||
        (
          ( col.id in row.values ) &&
          row.values[ col.id ].length &&
          row.values[ col.id ].findIndex( i => ( i.id || ( i.value === 0 || !!i.value ) ) ) >= 0
        )
      ) return false;

      return true;
    },

    colGetClass( col, cols, rows, row ) {
      let cn = "";

      const vs = row && row.violations ? row.violations : {};

      //if col is id
      if ( col.implicit && col.marked && col.marked.includes( "__id__" ) ) {
        let gsi = -1; //no severity;
        for ( const cid in vs ) {
          if ( vs.hasOwnProperty( cid ) ) {
            const si = this.$options.severities.indexOf( vs[ cid ].severity );
            if ( si >= 0 && ( gsi < 0 || si < gsi ) ) gsi = si;
          }
        }

        if ( gsi >= 0 ) cn += this.$options.severities[ gsi ].replace( /^[^#]+#/, "v" );
/*
        const table = this.$refs.main.$el.querySelector( "table" );
        if ( table && row && rows && col && cols ) {
          const rowN = rows.findIndex( i => i.id === row.id );
          let colN = 0;
          for ( const cid in cols ) {
            if ( cols.hasOwnProperty( cid ) && cols[ cid ] === col ) break;
            colN++;
          }

          if ( rowN >= 0 && colN >= 0 && table.rows && table.rows[ rowN + 1 ] ) {
            const el = table.rows[ rowN + 1 ].cells[ colN ];
            if ( el ) {
              const colors = [ "#FF0000", "#00FF00", "#0000FF" ];
              let lg = "";
              const gs = Math.ceil( 100 / colors.length );
              let g = 0;
              for ( const c of colors ) {
                lg += `${c} ${g}%, ${c} ${g + gs}%, `;
                g += gs;
              }
              lg = "linear-gradient( to top left, " + lg.slice( 0, -2 ) + " )";
//              el.style.setProperty( "background-image", "linear-gradient( to top left, #ff0000 0%, #ff0000 33%, #00ff00 33%, #00ff00 66%, #0000ff 66%, #0000ff 100% )", "important" );
              el.style.setProperty( "background-image", lg, "important" );
              console.log( el );
            }
          }
        }
*/
        if ( !cn.includes( "vViolation" ) && this.consMand && this.consMand.size ) cn += " consMandWarning";
      }
      else {
        if ( ( col.id in vs ) && vs[ col.id ] ) cn += vs[ col.id ].severity.replace( /^[^#]+#/, "v" );
        if ( this.consMandWarn( row, col ) ) cn += " consMandWarning";
      }

      cn = cn.trim();

      return cn ? cn : false;
    },
    colGetTitle( col, cols, rows, row ) {
      const msgs = [];

      //if col is id
      if ( col.implicit && col.marked && col.marked.includes( "__id__" ) && row.violations ) {
        for ( const cid in row.violations ) {
          if ( row.violations.hasOwnProperty( cid ) ) {
              const name = cid in cols && cols[ cid ] && cols[ cid ].name ? cols[ cid ].name : cid;
              msgs.push( `[${name}]: ${row.violations[ cid ].msg}` );
          }
        }
      }
      else {
        if ( row && row.violations && ( col.id in row.violations ) ) msgs.push( row.violations[ col.id ].msg );

        if ( this.consMandWarn( row, col ) ) msgs.push( this.$t( "ConsMandMsg" ) );
      }

      return msgs.join( "\n\n" );
    },

    storageEndpointDataSet( endpointId, data ) {
      ls.set( "Endpoint_" + this.endpointId, data, "editorView" );
    },
    storageEndpointDataGet( endpointId ) {
      let data = ls.get( "Endpoint_" + endpointId, "editorView" );
      if ( !data ) data = {};
      if ( !( "classes" in data ) ) data.classes = {};
      return data;
    },
    storageClassDataSet( endpointId, classId, classData ) {
      const data = this.storageEndpointDataGet( endpointId );
      if ( !( classId in data.classes ) ) data.classes[ classId ] = {};
      Object.assign( data.classes[ classId ], classData );
      this.storageEndpointDataSet( endpointId, data );
    },
    storageClassDataGet( endpointId, classId ) {
      const data = this.storageEndpointDataGet( endpointId );
      const classData = classId in data.classes ? data.classes[ classId ] : {};

      return classData;
    },

    async tableUpdate( data ) {
      this.tableUpdateEnable( false );

      let page;
      if ( data ) {
        page = data.page;
        let columns = data.columns;

        if (
          (
            JSON.stringify( columns )
            !==
            JSON.stringify( this.columns )
          )
        ) {
          this.rowsCount = null;

          page = 1;
          this.columns = columns;
          this.storageClassDataSet( this.endpointId, this.classId, { columns, page } );
/*
          let ds = ls.get( "Endpoint_" + this.endpointId, "editorView" );
          if ( !ds ) ds = {};
          if ( !( "classes" in ds ) ) ds.classes = {};
          if ( !( this.classId in ds.classes ) ) ds.classes[ this.classId ] = {};
          ds.classes[ this.classId ].columns = columns;
          ls.set( "Endpoint_" + this.endpointId, ds, "editorView" );
*/
        }
        else if ( this.page != page ) {
          this.storageClassDataSet( this.endpointId, this.classId, { page } );
        }
      }
      else {
        page = this.page;
      }

      if ( !this.classId ) this.rows = [];
      else {
        this.loading = true;

        const r = await this.rowsRequest( page );

        this.rows = r.rows;
        this.page = r.page;
        this.pages = r.pages ? r.pages : this.page;

        this.loading = false
      }

      this.tableUpdateEnable( true );
    },

    async XLSexport() {
      const cols = {};
      for ( const cid in this.columns ) {
        if ( this.columns.hasOwnProperty( cid ) ) {
          const col = this.columns[ cid ];
          if ( col.show && col.implicit !== true ) {
            cols[ cid ] = {
              name: col.name,
              type: this.columnGetType( cid )
            }
          }
        }
      }

      this.loading = true;
      try {
        await utils.downloadPost(
            this.$options.server.make( "/editing/export" ),
            {
              ...this.rowsRequestParams( this.page ),
              langInterf: this.langInterf,
              columns: cols
            }
        );
      }
      catch ( e ) {
        this.$root.$emit( "notify", { header: this.$t( "Error" ), message: e.message, type: "error" } );
      }
      this.loading = false;
    },

    async XLSimport() {
      this.XLSimportShow = true;
    },

    async XLSimportClose( reset ) {
      this.XLSimportError = null;
      this.XLSimportShow = false;
      if ( reset ) this.XLSimportData = null;
    },

    XLSimportRefresh( inputFileEl, filename ) {
      let data = null;

      this.XLSimportError = null;

      if ( inputFileEl && inputFileEl.files && inputFileEl.files.length ) {
        try {
          data = new FormData()
          data.append( "file", inputFileEl.files[0] )

          this.XLSimportData = {
            data,
            filename
          };
        }
        catch ( e ) {
          data = null;
          console.error( e );
          this.$root.$emit( "notify", { header: this.$t( "FileRequestError" ), message: e.message, type: "error" } );
        }
      }
      else this.XLSimportData = null;
    },

    async XLSimportDo( force ) {
      if ( !force && this.langData ) {
        this.modalOpen(
          this.$t( "XLSimportLangWarn", { lang: this.$t( this.langData ) } ),
          () => this.XLSimportDo( true ),
          "",
          null,
          this.$t( "Import" ),
          this.$t( "cancel" )
        );

        return;
      }

      if ( this.XLSimportData ) {
        try {
          this.loading = true;

          this.XLSimportData.data.set(
            "params",
            JSON.stringify(
              {
                classes:    this.classId,
                updateMode: this.XLSimportMode,
                ...this.apiQueryStd
              }
            )
          );

          const ans = await this.$options.api.rq(
            "POST",
            undefined,
            "json",
            "/editing/import",
            this.XLSimportData.data,
            { dataRaw: true },
            false
          );

          if ( !ans ) throw new Error( this.$t( "InvalidServerAnswer" ) );
          if ( ans.errors && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );

          if ( ans.rowsErrors && ans.rowsErrors.length ) {
            let html = '<table cellspacing="0" cellpadding="0" border="0" class="tableObjProps"><caption></caption><tr><th scope="row">' + this.$t( "String" ) + '&nbsp;№</th><th scope="row">' + this.$t( "URI" ) + '</th><th scope="row">' + this.$t( "Error" ) + '</th></tr>';
            for ( const rowErr of ans.rowsErrors ) {
              html += '<tr><td>' + rowErr.row + '</td><td>' + rowErr.id + '</td><td>' + rowErr.message + '</td></tr>';
            }
            html += '</table>'

            this.modalOpen( html, undefined, this.$t( "ImportErrors" ), undefined, this.$t( "Ok" ), "" );
          }
          else {
            this.$root.$emit( "notify", { message: this.$t( "file" ) + " " + ( this.XLSimportData.filename ? "\"" + this.XLSimportData.filename + "\" " : "" ) + this.$t( "importSucc" ), type: "info" } );
            //this.XLSimportData = null;
            this.XLSimportShow = false;
          }

          this.editing = {};
          await this.tableUpdate();
        }
        catch ( e ) {
          console.error( e );
          this.$root.$emit( "notify", { header: this.$t( "importErr" ), message: e.message, type: "error" } );
        }

        this.loading = false;
      }
      else {
        this.XLSimportError = this.$t( "SelectFile" );
      }
    },

    rowColClick( row, rowIndex, col, colId, isDoubleClick, e ) {
      //@dblclick="editingSet( $event, data, true )"
      if ( isDoubleClick ) {
        let t = e.target;
        for ( let i = 10; t && i > 0; i-- ) {
          if ( t.tagName == "TD" && t.classList.contains( "dblClkIgnore" ) ) return;
          t = t.parentNode;
        }

        if ( colId == "&id" ) {
          if ( row.new ) {
            if ( !( "idCorr" in row ) ) {
              this.$set( row, "idCorrVal", row.id );
              this.$set( row, "idCorr", true );
              this.$nextTick(
                () => {
                  const t = e.target.querySelector( "input" );
                  if ( t ) t.focus();
                }
              );
            }
          }
          else {
            ( window.getSelection ? window.getSelection() : document.selection ).empty(); //remove selection
            this.rowView( row.id )
          }
          return;
        }
        const target = e.target && e.target.classList.contains( "cell" ) ? e.target.querySelector( ".control" ) : e.target;

        this.editingSet( { ...e, target }, { row, columnId: colId }, true );
      }
    },

    editingData( rowId, colId ) {
      if ( ( rowId in this.editing ) && ( colId in this.editing[ rowId ] ) ) {
        const edtData = this.editing[ rowId ][ colId ];
        return edtData;
      }

      return null;
    },
    editingDataProp( rowId, colId, prop, propDefVal ) {
      const edtData = this.editingData( rowId, colId );
      if ( edtData && ( prop in edtData ) ) return edtData[ prop ];

      return propDefVal;
    },
    editingDataErrorIs( rowId, colId ) {
      const edtData = this.editingData( rowId, colId );
      if ( edtData ) {
        if ( edtData.errors.global ) return true;

        for ( const i in edtData.errors.fields ) {
          if ( edtData.errors.fields.hasOwnProperty( i ) ) return true;
        }
      }

      return false;
    },
    editingDataErrorGet( rowId, colId, valueId ) {
      const edtData = this.editingData( rowId, colId );
      if ( edtData ) {
        if ( valueId !== undefined ) {
          if ( valueId in edtData.errors.fields ) {
            return edtData.errors.fields[ valueId ];
          }
        }
        else if ( edtData.errors.global ) return edtData.errors.global;
      }

      return null;
    },
    editingDataErrorClear( rowId, colId, valueId ) {
      const edtData = this.editingData( rowId, colId );
      if ( edtData  ) {
        if ( valueId !== undefined ) {
          if ( valueId in edtData.errors.fields ) this.$delete( edtData.errors.fields, valueId );
        }
        else this.$set( edtData.errors, "global", null );
      }
    },
    editingDataErrorClearAll( rowId, colId ) {
      const edtData = this.editingData( rowId, colId );
      if ( edtData  ) {
        this.$set( edtData, "errors", { global: null, fields: {} } );
      }
    },
    editingDataErrorSet( rowId, colId, msg, valueId ) {
      const edtData = this.editingData( rowId, colId );
      if ( edtData && msg ) {
        if ( valueId !== undefined ) this.$set( edtData.errors.fields, valueId, msg );
        else this.$set( edtData.errors, "global", msg );
      }
    },
    rowData( rowId ) {
      const row = this.rows.find( i => i.id === rowId );
      return row ? row : null;
    },
    editingIs( rowId, colId ) {
      const edtData = this.editingData( rowId, colId );
      if ( edtData ) return edtData.show;

      return false;
    },
    editingRowIs( rowId ) {
      if ( ( rowId in this.editing ) ) {
        const cols = this.editing[ rowId ];
        for ( const colId in cols ) if ( cols.hasOwnProperty( colId ) && cols[ colId ].show ) return true;
      }

      return false;
    },
    editingIsValues( rowId, colId ) {
      const edtData = this.editingData( rowId, colId );
      if ( edtData && edtData.show ) {
        return edtData.values && edtData.values.length;
      }

      return false;
    },
    async editingSet( event, data, state ) {
      const rowId = data.row.id;
      const colId = data.columnId;

      let colVs = this.rowData( rowId );
      if ( !colVs ) return;

      colVs = JSON.parse( JSON.stringify( colVs.values[ colId ] ) );
      //remove inferred values from editing
      colVs = colVs.filter( i => !i.inferred );
/*
      //convert values from back format to the front format
      switch ( this.columnGetType( colId ).toLowerCase() ) {
        case "xsd:date":
        case "http://www.w3.org/2001/xmlschema#date":
         for ( let i = 0; i < colVs.length; i++ ) {
           const colV = colVs[ i ];
           if ( colV ) colVs[ i ] = dates.format( colV, dates.types.ISO, dates.types.RUS, false, true );
         }
        break;

        case "xsd:datetime":
        case "http://www.w3.org/2001/xmlschema#datetime":
         for ( let i = 0; i < colVs.length; i++ ) {
           const colV = colVs[ i ];
           if ( colV ) colVs[ i ] = dates.format( colV, dates.types.ISO, dates.types.RUS, true, true );
         }
        break;
      }
*/
      if ( state ) {
        if ( !( rowId in this.editing ) ) this.$set( this.editing, rowId, {} );
        if ( !( colId in this.editing[ rowId ] ) ) this.$set( this.editing[ rowId ], colId, { show: false, dom: null, class: null, el: null, values: [] } );

        const edtData = this.editing[ rowId ][ colId ];

        if ( !edtData.show ) {
          this.$set( edtData, "values", colVs );
          this.$set( edtData, "show", true );

          this.$set( edtData, "class", "" );

          this.$set( edtData, "errors", { global: null, fields: {} } );

          const el = utils.domFindUp( event.target, "control" );
          this.$set( edtData, "el", el );

          await this.$nextTick();
/*
          if ( el ) {
            let t = this.$refs.main.$el.getBoundingClientRect();l
            const wr = t.right + window.scrollX;
            t = el.getBoundingClientRect();
            const er = t.right + window.scrollX;

            console.log( wr, er );

//            el.classList.add( "opened" );
//            el.style.zIndex = this.editingZ++;
          }
*/
          if ( el ) {
            //if editing from empty state - emulate press "+" button to show input field
            const b = el.querySelector( ".field.empty > button" );
            if ( b ) b.click();

            const et = el.querySelector( ".tooltip" )
            if ( et ) et.style.zIndex = this.editingZ++

            const ef = el.querySelector( "*[data-focus]" );
            if ( ef ) ef.focus();
            //this.$set( edtData, "el", el.querySelector( ".fields" ) );

            //noinspection ES6MissingAwait
            this.onResize( () => { utils.scrollIntoViewIfNeeded( el.querySelector( ".content" ) ); } );
          }
        }
      }
      else {
        const edtData = this.editingData( rowId, colId );
        if ( edtData ) {
          if ( edtData.el ) {
//            edtData.el.classList.remove( "opened" );
            const et = edtData.el.querySelector( ".tooltip" );
            if ( et ) et.style.zIndex = "unset";
          }
          this.$delete( this.editing[ rowId ], colId );
          if ( utils.objIsEmpty( this.editing[ rowId ] ) ) this.$delete( this.editing, rowId );
        }
      }
    },
    async editingSaveValidation( rowId, colId ) {
      const col = this.columns && ( colId in this.columns ) ? this.columns[ colId ] : null;
      let edtData = this.editingData( rowId, colId );

      if ( !edtData || !edtData.show ) {
        await this.editingOpen( rowId, colId );
        edtData = this.editingData( rowId, colId )
      }

      if ( edtData && edtData.show ) {
        const values = utils.cloneDeep( edtData.values );

        //validation and convertation
        this.editingDataErrorClearAll( rowId, colId );

        if ( this.$refs ) {
          let dvfs = "DVfields_" + rowId + "_" + colId;
          if ( dvfs in this.$refs ) {
            dvfs = this.$refs[ dvfs ];
            if ( !Array.isArray( dvfs ) ) dvfs = [ dvfs ];
            for ( const f of dvfs ) if ( f && f.update ) f.update( false );
          }
        }
//        await this.$nextTick();
        if ( this.editingDataErrorIs( rowId, colId ) ) return null;

        const colType = this.columnGetType( colId );
        let msg = null;

        for ( let vk = 0; vk < values.length; vk++ ) {
          const v = values[ vk ];
          let vv = v.value;

          switch( ( "" + colType ).toLowerCase() ) {
            case "reference":
              vv = v;
              if ( !vv || !vv.id ) msg = "<b>" + this.$t( "RefCantEmpty" ) + ".</b><br /><br />" + this.$t( "RefFillOrRemove" ) + ".";
            break;

            case "xsd:date":
            case "http://www.w3.org/2001/xmlschema#date":
              vv = ( vv + "" ).trim();
              if ( vv && !dates.check( vv, dates.types.ISO ) ) msg = "<b>" + this.$t( "InvalidDateFormat" ) + ".</b><br /><br />" + this.$t( "UseDateFormat" );
            break;

            case "xsd:datetime":
            case "http://www.w3.org/2001/xmlschema#datetime":
              vv = ( vv + "" ).trim();
              if ( vv && !dates.check( vv, dates.types.ISO, true ) ) msg = "<b>" + this.$t( "InvalidDateFormat" ) + ".</b><br /><br />" + this.$t( "UseDatetimeFormat" );
            break;

            case "xsd:double":
            case "http://www.w3.org/2001/xmlschema#double":
              if ( !/^\s*-?\d+(?:\.\d+)?\s*/.test( vv ) ) msg = "<b>" + this.$t( "InvalidDoubleFormat" ) + ".</b>";
            break;

            case "xsd:integer":
            case "http://www.w3.org/2001/xmlschema#integer":
              if ( !/^\s*-?\d+\s*/.test( vv ) ) msg = "<b>" + this.$t( "InvalidIntegerFormat" ) + ".</b>";
            break;
          }

          if ( msg ) {
            this.editingDataErrorSet( rowId, colId, msg, vk );
            return null;
          }
        }

        if ( !msg && col && col.carMin ) {
          let filled = 0;
          for ( const v of values ) if ( v.value !== "" && v.value !== null && v.value !== undefined ) filled++;
          if ( filled < col.carMin ) {
            this.editingDataErrorSet( rowId, colId, "<b>" + this.$t( "MinFieldsFilled" ) + " - " + col.carMin + "</b><br /><br />" + this.$t( "FillMissingFields" ) + "." );
            return null;
          }
        }

        return {
          [ colId ]: values
        };
      }

      return null;
    },
    async editingSave( rowId, colId ) {
      let ans = null;

      const attrs = {};
      const row = this.rowData( rowId );
      const create = !!row.new;
      const edtDatas = [];

      let n = 0;
      for ( const cid in this.columns ) {
        if ( this.columns.hasOwnProperty( cid ) ) {
          const col = this.columns[ cid ];
          n++;

          //if all columns, or specified columns or column with restriction
          if ( !colId || cid == colId || col.carMin ) {
            const edtData = this.editingData( rowId, cid );
            //if editing
            if ( edtData ) {
              const colAttrs = await this.editingSaveValidation( rowId, cid );
              if ( colAttrs ) {
                Object.assign( attrs, colAttrs );
                edtDatas.push( edtData );
              }
              else {
                return;
              }
            }
            else if ( col.carMin ) {
              if ( row.new ) {
                await this.editingSaveValidation( rowId, cid );

                if ( !this.columns[ cid ].show ) this.$root.$emit( "notify", { header: this.$t( "ObjectsSaveError" ), message: "<b>" + this.$t( "MinFieldsFilled" ) + " «" + ( col.name ? col.name : col.id ) + "» - " + col.carMin + "</b><br /><br />" + this.$t( "FillMissingFields" ) + ".", type: "error" } );

                return;
              }
            }
          }
        }
      }

      if ( utils.objIsEmpty( attrs ) ) {
        this.$root.$emit( "notify", { message: this.$t( "NothingSave" ), type: "info" } );
        return;
      }
/*
      //if only
      if ( create && n == 1 ) {
        for ( const cid in this.columns ) {
          if ( this.columns.hasOwnProperty( cid ) ) {
            const col = this.columns[ cid ];

            if ( col.carMin ) {
              const attr = await this.editingSaveValidation( rowId, cid );
              if ( !attr ) return;
              Object.assign( attrs, attr );
            }
          }
        }
      }
*/
      edtDatas.forEach( d => { if ( d.el ) d.el.classList.add( "loading" ); } );
      if ( row.idCorr ) this.$set( row, "idCorrLoading", true );

      const classes = create ? [ this.classId ] : Object.keys( row.classes );
      try {
        ans = await this.$options.api[ create ? "put" : "patch" ].json(
          "/editing",
          {
            ...this.apiQueryStd,
            classes,
            id:  create && row.idCorr && row.idCorrVal ? row.idCorrVal : rowId,
            attrs,
          },
          undefined,
          false
        );

        if ( !ans || ( ans.errors && ans.errors.length ) || !ans.id ) {
          this.$root.$emit( "notify", { header: this.$t( "ObjectsSaveError" ), message: ans ? ans.errors.join( "<br />" ) : this.$t( "InvalidServerAnswer" ), type: "error" } );
        }
        else {
          if ( ans.violations && ans.violations.length ) {
            let text = this.$t( "ViolationConstraintsRules" ) + ":";
            for ( const v of ans.violations ) {
              text += "<br />" + v.Message;
            }

            this.$root.$emit( "notify", { header: this.$t( "ViolationsDetected" ), message: text, type: "warning" } );
          }

          const affected = ans.affected || {};

          const rowIdNew = ans.id;

          ans = await this.$options.api.post.json(
            "/editing",
            {
              ...this.apiQueryStd,
              id:  rowIdNew
            },
            undefined,
            false
          );

          if ( !ans || ( ans.errors && ans.errors.length ) || !ans.item ) {
            this.$root.$emit( "notify", { header: this.$t( "SavedObjectGetError" ), message: ans.errors.length ? ans.errors.join( "<br />" ) : this.$t( "InvalidServerAnswer" ), type: "error" } );
          }
          else {
            const item = ans.item;
            const row = this.rowFromItem( item );
            row.violations = ( await this.violationsGet( rowIdNew ) )[ rowIdNew ];

            const rowI = this.rows.findIndex( i => i.id === rowId );
            this.$set( this.rows, rowI, row );

            let msg = "";
            if ( !utils.objIsEmpty( affected ) ) {
              msg += this.$t( "ObjectsChangedByRules" ) + ': ';
              for ( const oid in affected ) {
                if ( affected.hasOwnProperty( oid ) ) {
                  msg += "\"<b>" + affected[ oid ] + "</b>\", "
                }
              }
              msg = msg.slice( 0, -2 );
            }
            this.$root.$emit( "notify", { header: this.$t( "Object" ) + " «" + ( item.name ? item.name : item.id ) + "» " + this.$t( "savedSuc" ), message:  msg, type: "info" } );

            edtDatas.forEach( d => { d.show = false; } );
          }
        }
      }
      catch ( e ) {
          this.$root.$emit( "notify", { header: this.$t( "ObjectsSaveError" ), message: e.message, type: "error" } );
          console.error( e );
      }

      edtDatas.forEach( d => { if ( d.el ) d.el.classList.remove( "loading" ); } );
      if ( row.idCorr ) this.$delete( row, "idCorrLoading" );
    },
    editingDiscard( event, rowId, colId ) {
      const edtData = this.editingData( rowId, colId );
      if ( edtData && edtData.show ) edtData.show = false;
    },

    editingFieldCanAdd( rowId, colId ) {
      let col = this.columns && ( colId in this.columns ) ? this.columns[ colId ] : null;
      if ( !col || col.carMax === 0 ) return false;
      if ( col.carMax === null ) return true;

      let ed = this.editingData( rowId, colId );
      return ed ? ed.values.length < col.carMax  : false;
    },

    editingFieldCanRemove( rowId, colId ) {
      let col = this.columns && ( colId in this.columns ) ? this.columns[ colId ] : null;
      if ( !col ) return false;
      if ( col.carMin === null ) return true;

      let ed = this.editingData( rowId, colId );
      return ed ? ed.values.length > col.carMin  : false;
    },

    editingFieldAdd( event, rowId, colId, vi ) {
      const data = this.editingData( rowId, colId );
      if ( data && data.show ) {
        let el = utils.domFindUp( event.target, "fields" );

        let nums = 1;
        const col = this.columns && ( colId in this.columns ) ? this.columns[ colId ] : null;
        if ( col && col.carMin && data.values.length < col.carMin ) nums = col.carMin - data.values.length;

        const t = this.columnGetType( colId );
        const v = {
          lang: null
        };
        switch ( t.toLowerCase() ) {
          case "reference":
            v.id = null;
            v.name = "";
          break;

          case "xsd:boolean":
          case "http://www.w3.org/2001/xmlschema#boolean":
            v.value = true;
          break;

          case "xsd:string":
          case "http://www.w3.org/2001/xmlschema#string":
            v.value = "";
            v.lang = this.langData;
          break;

          default:
            v.value = "";
        }

        while ( nums > 0 ) {
          nums--;
          data.values.splice( vi + 1, 0, v );
        }
        //data.values.splice( vi + 1, 0, v );

        this.$nextTick( () => {
          if ( el ) {
            el = el.querySelector( ".field:nth-child(" + ( vi + 2 ) + ") *[data-focus]" );
            if ( el ) el.focus();
          }
        } );
      }
    },
    editingFieldRemove( event, rowId, colId, vi ) {
      const data = this.editingData( rowId, colId );
      if ( data && data.show ) {
        let el = utils.domFindUp( event.target, "fields" );
        data.values.splice( vi, 1 );

        this.$nextTick( () => {
          if ( el ) {
            el = el.querySelector( ".field:nth-child(" + ( vi + 1 ) + ") *[data-focus]" ) || el.querySelector( ".field:nth-child(" + ( vi ) + ") *[data-focus]" );
            if ( el ) el.focus();
          }
        } );
      }
    },

    async editingOpen( rowId, colId, msg ) {
      if ( !this.columns[ colId ].show ) return; //if column is hidden

      const ed = this.editingData( rowId, colId );
      if ( ed && ed.show ) {
        ed.el.scrollIntoView( { block: "nearest" } );
      }
      else {
        const rowI = this.rows.findIndex( i => i.id == rowId );
        const tableRowCells = this.$refs.main.$el.querySelector(".table").rows[ rowI + 1 ].cells; //very dirty hack, don't do such things

        let colI = 0;
        for ( const cid in this.columns ) {
          if ( this.columns.hasOwnProperty( cid ) && this.columns[ cid ].show ) {
            if ( cid === colId ) break;
            colI++;
          }
        }

        const el = colI < tableRowCells.length ? tableRowCells[ colI ].querySelector( ".control" ) : null;

        await this.editingSet( { target: el }, { row: { id: rowId }, columnId: colId }, true );
      }

      if ( msg ) this.editingDataErrorSet( rowId, colId, msg );
    },
    async rowAdd( rowId ) {
      let rowI = this.rows.findIndex( i => i.id == rowId );
      if ( rowI < 0 ) rowI = this.rows.length;
      const row = {
        id:       utils.uniqueHashGen( "new_" ),
        new:      true,
        values:   {},
        columns:  {}
      };
      for ( const colId in this.columns ) {
        if ( this.columns.hasOwnProperty( colId ) ) {
          row.values[ colId ] = [];
          row.columns[ colId ] = "";
        }
      }

      if ( rowI >= 0 ) {
        rowI++;
        this.rows.splice( rowI, 0, row );

        await this.$nextTick();

        for ( const colId in this.columns ) {
          if ( this.columns.hasOwnProperty( colId ) ) {
            const col = this.columns[ colId ];

            if ( col.carMin ) await this.editingOpen( row.id, colId );
          }
        }
      }
    },
    rowView( id ) {
      let t = this.rowData( id );
      if ( t ) t = t.name;
      const aqs = this.apiQueryStd;
      this.$router.push( { name: "objectView", params: { id, endpoint: aqs.endpoint, classId: this.classId, name: t } } );
    },
    rowViewClosed() {
      const path = this.$route.path.replace( /\/object\/.*$/, "" );
      this.$router.push( path ? path : "/" );
    },
    async rowsAlignment() {
      //left only new rows or editing rows
      let rows = this.rows.filter(
          r => r.new || this.editingRowIs( r.id )
      );
      const rowsFrozen = [ ...rows ];

      let page = this.page + 1;
      while ( true ) {
        page--;
        if ( page < 1 ) break;

        const need = this.limit - rows.length;
        if ( need <= 0 ) break;

        const r = await this.rowsRequest( page );
        let rowsR = r ? r.rows : null;

        if ( page >= this.page ) this.pages = r.pages;
/*
        //if current page or greater has been requested, and no items are returned, and pages > 1 - decrease total pages in control by 1
            page >= this.page &&
            ( !rowsR || ( rowsR && !rowsR.length ) ) &&
            this.pages > 1
        ) {
          this.pages--;
          this.page = this.pages;
        }
*/
        //left only those requested rows which doesn't exists in current rows
        rowsR = rowsR.filter( i => ( rows.find( j => j.id == i.id ) === undefined ) );
        rows = page < this.page ? [ ...rowsR, ...rows ] : [ ...rows, ...rowsR ];
      }

      //sorting, if exists
      const ps = this.rowsRequestParams( this.page );
      if ( !utils.objIsEmpty( ps.sort ) ) {
        const sColId = ps.sort.id;
        const sDsc = ps.sort.type == "asc" ? 1 : -1;
        const sType = this.columnGetType( sColId ).toLowerCase();

        rows.sort(
          ( a, b ) => {
             let t;
             t = a.attrs ? a.attrs[ sColId ] : null;
             let av = t && t.values.length ? t.values[ 0 ] : null;
             if ( !av ) av = { id: "", name: "", value: "" }; //no value

             t = b.attrs ? b.attrs[ sColId ] : null;
             let bv = t && t.values.length ? t.values[ 0 ] : null;
             if ( !bv ) bv = { id: "", name: "", value: "" }; //no value

             let c = 0;
             switch ( sType ) {
               //compare as strings by name, or id if name is empty
               case "reference":
                 av = "" + ( av.name ? av.name : av.id );
                 bv = "" + ( bv.name ? bv.name : bv.id );

                 c = av.localeCompare( bv );
               break;

               //false, then true
               case "xsd:boolean":
               case "http://www.w3.org/2001/xmlschema#boolean":
                 av = av.value === "true" || av.value === true || av.value === 1 || av.value === "1" ? 1 : 0;
                 bv = bv.value === "true" || bv.value === true || bv.value === 1 || bv.value === "1" ? 1 : 0;
                 if ( av > bv ) c = -1;
                 else if ( av < bv ) c = 1;
               break;

               //integers
               case "xsd:integer":
               case "http://www.w3.org/2001/xmlschema#integer":
                 av = parseInt( "" + av.value, 10 );
                 if ( isNaN( av ) ) av = 0;
                 bv = parseInt( "" + bv.value, 10 );
                 if ( isNaN( bv ) ) bv = 0;

                 c = av - bv;
               break;

               case "xsd:double":
               case "http://www.w3.org/2001/xmlschema#double":
                 av = parseFloat( "" + av.value );
                 if ( isNaN( av ) ) av = 0;
                 bv = parseFloat( "" + bv.value );
                 if ( isNaN( bv ) ) bv = 0;

                 c = av - bv;
               break;

               case "xsd:date":
               case "http://www.w3.org/2001/xmlschema#date":
                 t = dates.format( "" + av.value, dates.types.RUS4Y, dates.types.STRUCT, false, true );
                 av = t && t.day ? t.UTS : 0;
                 t = dates.format( "" + bv.value, dates.types.RUS4Y, dates.types.STRUCT, false, true );
                 bv = t && t.day ? t.UTS : 0;

                 c = av - bv;
               break;

               case "xsd:datetime":
               case "http://www.w3.org/2001/xmlschema#datetime":
                 t = dates.format( "" + av.value, dates.types.RUS4Y, dates.types.STRUCT, false, true );
                 av = t && t.day && t.hours !== undefined ? t.UTS : 0;
                 t = dates.format( "" + bv.value, dates.types.RUS4Y, dates.types.STRUCT, false, true );
                 bv = t && t.day && t.hours !== undefined ? t.UTS : 0;

                 c = av - bv;
               break;

               //strings
               default:
                 c = ( "" + av.value ).localeCompare( "" + bv.value );
             }

             return sDsc * c;
          }
        );
      }

      if ( rows.length > this.limit ) {
        let extra = rows.length - this.limit;

        const chopStart = () => {
          if ( extra > 0 ) {
            let itemsN = 0;
            for ( const row of rows ) {
              if ( rowsFrozen.includes( row ) ) break;
              itemsN++;
            }
            if ( itemsN ) {
              const n = Math.min( extra, itemsN );
              rows.splice( 0, n );
              extra -= n;
            }
          }
        };
        const chopEnd = () => {
          if ( extra > 0 ) {
            let itemsN = 0;
            for ( let i = rows.length - 1; i >= 0; i-- ) {
              const row = rows[ i ];
              if ( rowsFrozen.includes( row ) ) break;
              itemsN++;
            }
            if ( itemsN >= 0 ) {
              const n = Math.min( extra, itemsN );
              rows.splice( l - n + 1, n );
              extra -= n;
            }
          }
        };

        if ( page >= this.page ) {
          chopEnd();
          chopStart();
        }
        else {
          chopStart();
          chopEnd();
        }
      }

      this.rows = rows;
    },
    async rowDelete( rowId ) {
      const rowI = this.rows.findIndex( i => i.id === rowId );
      const row = rowI >= 0 ? this.rows[ rowI ] : null;

      if ( row ) await this.rowsDelete( [ row ] )
    },
    async rowsDelete( rowsToDel ) {
      let rowsDel = Array.isArray( rowsToDel ) ? rowsToDel : [];
      if ( !rowsDel.length ) {
        for ( let rowI = 0; rowI < this.rows.length; rowI++ ) {
          const row = this.rows[ rowI ];
          if ( row.selected ) rowsDel.push( row );
        }
      }

      if ( !rowsDel.length ) {
        if ( !rowsToDel ) this.$root.$emit( "notify", { message: this.$t( "MarkAtleastOne" ), type: "info" } );
        return;
      }

      let html = rowsDel.reduce( ( a, i ) => a + ( a ? "<br />" : "" ) + this.rowGetAsHTML( i ), "" );

      const del = async () => {
        const rowsDelExisted = [];
        for ( const rowDel of rowsDel ) {
          if ( rowDel.new ) {
            const rowI = this.rows.findIndex( i => i === rowDel );
            if ( rowI >= 0 ) this.rows.splice( rowI, 1 );
          }
          else rowsDelExisted.push( rowDel );
        }

        if ( !rowsDelExisted.length ) return;

        this.loading = true;

        let ans;
        try {
          ans = await this.$options.api.delete.json(
            "/editing",
            {
              ...this.apiQueryStd,
              ids: rowsDelExisted.map( i => i.id )
            },
            undefined,
            false
          );

          for ( const rowDel of rowsDelExisted ) {
            const rowI = this.rows.findIndex( i => i === rowDel );
            if ( rowI >= 0 ) this.rows.splice( rowI, 1 );
          }
        }
        catch ( e ) {
          ans = {
            errors: [ e.message ]
          };
        }

        if ( !ans || ( ans.errors && ans.errors.length ) ) {
          this.$root.$emit( "notify", { header: this.$t( "DeleteError" ), message: ans.errors.length ? ans.errors.join( "<br />" ) : this.$t( "InvalidServerAnswer" ), type: "error" } );
        }
        else {
          await this.rowsAlignment();
        }

        this.loading = false;
      };

//if no need to confirm 1 item - uncomment it
//      if ( Array.isArray( rowsToDel ) && rowsToDel.length == 1 ) del();
//      else {
        this.modalOpen(
          html,
          del,
          this.$t( "DeleteObjects" ),
          undefined,
          this.$t( "Delete" )
        );
//      }
    },
    columnGet( colId ) {
      return colId && this.columns && ( colId in this.columns ) ? this.columns[ colId ] : null;
    },

    columnGetType( colId, removeXSD ) {
      const col = this.columnGet( colId );
      let type;

      if ( col ) {
        type = col.type;
        if ( removeXSD ) type = type.replace( /^xsd:/i, "" );
      }
      else type = null;

      return type;
    },

    columnGetAlign( colId ) {
      switch ( this.columnGetType( colId ).toLowerCase() ) {
         case "xsd:integer":
         case "http://www.w3.org/2001/xmlschema#integer":
           return "right";
      }

      return "left";
    },

    columnGetClasses( colId ) {
      const col = this.columnGet( colId );
      if ( col.type === "reference" ) return Object.keys( col.refs );
      return [];
    },

    async qualityRequest() {
      this.$set( this.quality, "tip", false );
      this.$set( this.quality, "total", null );
      this.$set( this.quality, "incorrect", null );
      this.$set( this.quality, "violations", null );
      this.$set( this.quality, "validPercent", null );

      try {
         const ans = await this.$options.api.post.json(
          "/quality",
          {
            ...this.apiQueryStd,

            id:       this.classId
          }
        );

/*
ans.quality = {
    total:        100,
    incorrect:    5,
    violations:   10,
    validPercent: 30
};
/**/
        if ( ans && ans.quality && ans.quality.total ) {
          this.$set( this.quality, "total", ans.quality.total );
          this.$set( this.quality, "incorrect", ans.quality.incorrect );
          this.$set( this.quality, "violations", ans.quality.violations );
          this.$set( this.quality, "validPercent", ans.quality.validPercent );

          const shapes = ans.quality.shapes || {};
          let countTotal = 0;
          utils.objEach( shapes, i => { countTotal += i.count; } );
          this.$set(
            this.quality,
            "shapes",
            Object.assign(
              shapes,
              { " OWV":  { special: "OWV", name: this.$t( "DataQualityOWV" ), count: countTotal } },
              { " ALL": { special: "ALL", name: this.$t( "DataQualityALL" ), count: null } },
            )
          );
        }
        if ( !this.quality.total && this.quality.active ) this.$set( this.quality, "active", false );

      }
      catch ( e ) {
        console.error( e );
      }
    },

    async classMenu( n ) {
//      if ( this.classMenuS !== null ) return;

      this.classMenuS = n;

      let error = null, errorPrefix = null;
      let itemsFound = null;

      switch ( this.classMenuS ) {
        case "constraints":
          this.classMenuS = null;
          this.classMenuProcessingPercentage = null;
          this.constraintsSearchingShow = true;
          await this.$nextTick();
          this.$refs.constraintsSearchingSortField.$el.querySelector( "input" ).focus();
        return;

        case "constraintsApply":
          try {
            if ( !this.constraintsSearchingSortClass || !this.constraintsSearchingSortClass.id ) {
              this.classMenuS = null;

              this.constraintsSearchingError = this.$t( "ConstraintsSearchingSpecifySort" );
              return;
            }

            this.constraintsSearchingShow = false; //close dialog

            this.classMenuProcessingPercentage = 0;

            const ans = await this.$options.api.post.json(
              "/violations/check/schedule",
                {
                  ...this.apiQueryStd,
                  id: this.classId,
                  sortId: this.constraintsSearchingSortClass.id,
                  chunkSize: this.chunkSize
                }
            );

            if ( !ans ) throw new Error( "malformed server answer" );
            if ( ans.error ) throw new Error( ans.error );
            if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );

            if ( ans.id ) {
              const taskId = ans.id;

              await utils.delay( 5000 ); //this is for fast cases - wait for 5 secs and made first request for status
              while ( true ) {
                const ans = await this.$options.api.post.json(
                  "/violations/check/schedule/status",
                    {
                      ...this.apiQueryStd,
                      id: taskId
                    }
                );

                if ( "percentage" in ans ) {
                  let p = ans.percentage;
                  if ( Number.isInteger( p ) ) {
                    if ( p < 0 ) p = 0;
                    if ( p > 100 ) p = 100;
                    this.classMenuProcessingPercentage = p;
                  }
                }

                //if finished
                if ( this.classMenuProcessingPercentage >= 100 ) break;

                await utils.delay( 60000 ); //delay by a minute
              }

              const vss = this.rows.length ? await this.violationsGet( this.rows.map( i => i.id ) ) : {};
              itemsFound = Object.keys( vss ).length;

              for ( const row of this.rows ) {
                const rid = row.id;
    /*
                const attrs = {};
                let found = false;
                if ( rid && rid in vss ) {
                  for ( const v of vss[ rid ].items ) {
                    if ( v.attrs ) {
                      for ( const a of v.attrs ) {
                        if ( !( a in attrs ) ) attrs[ a ] = "";
                        attrs[ a ] += ( attrs[ a ] ? "; " : "" ) + v.msg;
                        found = true;
                      }
                    }
                  }
                }

                this.$set( row, "violations", found ? attrs : null );
    */
                this.$set( row, "violations", rid in vss ? vss[ rid ] : null );
              }

              //noinspection ES6MissingAwait
              this.qualityRequest();

              this.classMenuProcessingPercentage = null;
            }
            else throw new Error( "can't get scehduled id, possibly storage doesn't allow async operations" );
          }
          catch ( e ) {
            this.classMenuProcessingPercentage = null;
            error = e;
            errorPrefix = "APPLY CONSTRAINTS ERROR: ";
          }
        break;

        case "duplicates":
          this.classMenuS = null;

          this.duplicateFindingRules = null;
          this.duplicateFindingRulesShow = true;
          this.duplicateFindingRuleSelected = null;

          try {
            const ans = await this.$options.api.post.json(
              "/entities",
                {
                  ...this.apiQueryStd,
                  classes: [ "http://www.w3.org/ns/shacl#Shape" ],
                  filters: {
                      "http://www.w3.org/ns/shacl#targetClass": {
                        values:     this.classId,
                        comparison: "equal",
                        byName:     false
                      }
                  },
                  sort: {
                    id: "rdfs:label",
                    type: "asc"
                  }
                }
            );

            if ( !ans ) throw new Error( "malformed server answer" );
            if ( ans.error ) throw new Error( ans.error );
            if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );
            if ( !( "items" in ans ) ) throw new Error( this.$t( "InvalidServerAnswer" ) + ": " + JSON.stringify( ans ) );

            const shapes = ans.items;

            //filter shapes, which are connected to object of rule class
            const ps = {};
            const shapes2rule = {};
            for ( const shapeId in shapes ) {
              if ( shapes.hasOwnProperty( shapeId ) ) {
                const shape = shapes[ shapeId ];

                const ruleId = "http://www.w3.org/ns/shacl#sparql" in shape.attrs &&
                  Array.isArray( shape.attrs["http://www.w3.org/ns/shacl#sparql"].values ) &&
                  shape.attrs["http://www.w3.org/ns/shacl#sparql"].values.length
                  ?
                  shape.attrs["http://www.w3.org/ns/shacl#sparql"].values[0].id
                  :
                  null;

                shapes2rule[ shapeId ] = ruleId;

                if ( ruleId && !( ruleId in ps ) ) {
                  ps[ ruleId ] = this.$options.api.post.json(
                    "/entity",
                    {
                      ...this.apiQueryStd,
                      id: ruleId,
                      short: true
                    }
                  );
                }
              }
            }

            const rulesIsRight = {};
            try {
              const psAs = await Promise.all( Object.values( ps ) );
              for ( const psA of psAs ) {
                if ( psA && psA.item && psA.item.classes && "http://www.w3.org/ns/shacl#SPARQLRule" in psA.item.classes ) {
                  const ruleId = psA.item.id;
                  rulesIsRight[ ruleId ] = psA;
                }
              }
            }
            catch ( e ) {
              console.error( e );
            }

            //prepare for menu
            const items = {};
            let itemFirstId = null;
            for ( const shapeId in shapes ) {
              if ( shapes.hasOwnProperty( shapeId ) ) {
                const shape = shapes[ shapeId ];
                const ruleId = shapeId in shapes2rule ? shapes2rule[ shapeId ] : null;

                if ( ruleId && ruleId in rulesIsRight ) {
                  if ( itemFirstId === null ) itemFirstId = shapeId;
                  items[ shapeId ] = shape.name;
                }
              }
            }

            this.duplicateFindingRules = items;
            this.duplicateFindingRuleSelected = itemFirstId;

            return;
          }
          catch ( e ) {
            error = e;
            errorPrefix = "DUPLICATES FINDING ERROR: ";
          }
        break;

        case "duplicatesApply":
          this.duplicateFindingRulesShow = false;
          this.classMenuS = "duplicates";

          try {
            if ( !this.duplicateFindingRuleSelected ) throw new Error( "no rule is selected" );

            const ans = await this.$options.api.post.json(
              "/duplicates/check",
                {
                  ...this.apiQueryStd,
                  id:     this.classId,
                  ruleId: this.duplicateFindingRuleSelected
                }
            );

            if ( !ans ) throw new Error( "malformed server answer" );
            if ( ans.error ) throw new Error( ans.error );
            if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );
          }
          catch ( e ) {
            error = e;
            errorPrefix = "DUPLICATES FINDING ERROR: ";
          }
        break;

        case "references":
          this.classMenuS = null;
          this.referencesRefreshingShow = true;
        return;

        case "referencesApply":
          this.referencesRefreshingShow = false;
          this.classMenuS = "references";

          try {
            const ans = await this.$options.api.post.json(
              "/references/check",
                {
                  ...this.apiQueryStd,
                  id:               this.classId,
                  setReferenceLink: this.referencesRefreshingSetReferenceLink,
                  writeProvenance:  this.referencesRefreshingWriteProvenance
                }
            );

            if ( !ans ) throw new Error( "malformed server answer" );
            if ( ans.error ) throw new Error( ans.error );
            if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );

            itemsFound = ans.total;
          }
          catch ( e ) {
            error = e;
            errorPrefix = "REFERENCES FINDING ERROR: ";
          }
        break;
      }

      if ( error ) {
        console.error( errorPrefix + error.message, error.stack );
        this.$root.$emit( "notify", { header: this.classMenuMsgGet( "error", true ), message: error.message, type: "error" } );
      }
      else this.$root.$emit( "notify", { header: this.$t( 'OperationFinished' ), message: this.classMenuMsgGet( "finished", true, { count: itemsFound } ), type: "info" } );

      this.classMenuS = null;
    },

    classMenuMsgGet( mode, useCurrentSelected, tplData ) {
      if ( useCurrentSelected ) return this.classMenuS ? this.$t( "classMenu." + mode + "." + this.classMenuS.replace( /^([^A-Z]+).*$/, "$1" ), tplData ) : "";

      return this.$t( "classMenu." + mode, tplData );
    },

    constraintsSearchingSortItems( query ) {
      const attrs = [];

      if ( this.columns ) {
        if ( query ) query = query.toLowerCase();
        for ( const id in this.columns ) {
          if ( id[0] != "&" && this.columns.hasOwnProperty( id ) ) {
            const column = this.columns[ id ];
            if ( !query || column.name.toLowerCase().includes( query ) ) attrs.push( { id, name: column.name } );
          }
        }
      }

      return attrs;
    },

    filtersSortsRemove() {
      const columns = JSON.parse( JSON.stringify( this.columns ) );
      if ( columns ) {
        for ( const cid in columns ) {
          if ( columns.hasOwnProperty( cid ) ) {
            const c = columns[ cid ];
            if ( c.sort == "asc" || c.sort == "dsc" ) c.sort = "";
            const filter = c.filter;
            const fo = utils.objIs( filter );
            if ( fo ) filter.value = "";
            else c.filter = "";
          }
        }

        this.tableUpdate( { columns } );
      }
    },

    qualityGetClassName( shapeId ) {
      let cn = "shape";
      if ( shapeId[0] === " " ) cn += shapeId;
      if (
          shapeId == this.quality.active ||
          ( shapeId == " OWV" && this.quality.active === true ) ||
          ( shapeId == " ALL" && !this.quality.active )
      ) cn += " active";

      return cn;
    },
    qualitySetActive( shapeId ) {
      const active = shapeId == " ALL" ? null : ( shapeId == " OWV" ? true : shapeId );

      this.$set( this.quality, "active", active );
    },
    qualityMouseLeave( e ) {
      const el = this.$refs.quality;
      if ( el && !el.contains( e.relatedTarget ) ) this.$set( this.quality, "tip", false );
    },

    async schedulerXLSimport() {
      this.schedulerXLSimportShow = true;
    },

    async schedulerXLSimportClose( reset ) {
      this.schedulerXLSimportError = null;
      this.schedulerXLSimportShow = false;
      if ( reset ) this.schedulerXLSimportData = null;
    },

    schedulerXLSimportRefresh( inputFileEl, filename ) {
      let data = null;

      this.schedulerXLSimportError = null;

      if ( inputFileEl && inputFileEl.files && inputFileEl.files.length ) {
        try {
          data = [];
          for ( const f of inputFileEl.files ) {
            const d = new FormData()
            d.append( "file", f );
            data.push( d );
          }

          this.schedulerXLSimportData = {
            data,
            filename
          };
        }
        catch ( e ) {
          data = null;
          console.error( e );

          this.$root.$emit( "notify", { header: this.$t( "FileRequestError" ), message: e.message, type: "error" } );
        }
      }
      else this.schedulerXLSimportData = null;
    },

    async schedulerXLSimportDo( force ) {
      if ( !force && this.langData ) {
        this.modalOpen(
          this.$t( "XLSimportLangWarn", { lang: this.$t( this.langData ) } ),
          () => this.schedulerXLSimportDo( true ),
          "",
          null,
          this.$t( "Import" ),
          this.$t( "cancel" )
        );

        return;
      }

      if ( this.schedulerXLSimportData ) {
        for ( const d of this.schedulerXLSimportData.data ) {
          d.set(
            "params",
            JSON.stringify(
                {
                  classes:    this.classId,
                  updateMode: this.schedulerXLSimportMode,
                  applyRules: this.schedulerApplyRules,
                  ...this.apiQueryStd,
                  type: "XLSimport"
                }
            )
          );

          this.$refs.scheduler.taskCreate( d );
        }

        this.schedulerXLSimportShow = false;
      }
      else {
        this.schedulerXLSimportError = this.$t( "SelectFile" );
      }
    },

    schedulerXLSexport() {
      if ( !this.schedulerParams.sort || !this.schedulerParams.sort.id ) {
        this.modalOpen( this.$t( "XLSexportNoSort" ), undefined, this.$t( "Error" ), undefined, this.$t( "Ok" ), "" );
        return;
      }

      this.$refs.scheduler.taskCreate( "XLSexport" );
    }
  },

  computed: {
    schedulerParams() {
      const cols = {};
      for ( const cid in this.columns ) {
        if ( this.columns.hasOwnProperty( cid ) ) {
          const col = this.columns[ cid ];
          if ( col.show && col.implicit !== true ) {
            cols[ cid ] = {
              name: col.name,
              type: this.columnGetType( cid )
            }
          }
        }
      }

      const params = {
        ...this.rowsRequestParams( this.page ),
        langInterf: this.langInterf,
        columns: cols
      };

      return params;
    },

    apiQueryStd() {
      return {
        ...this.queryStd,

        endpoint: this.endpointId,
        clientId: this.$store.getters["user/getClientId"](),

        langInterf: this.langInterf
      };
    },

    filtersSortsAppliedIs() {
      this.filtersSortsAppliedShow = false;

      if ( this.columns ) {
        for ( const cid in this.columns ) {
          if ( this.columns.hasOwnProperty( cid ) ) {
            const c = this.columns[ cid ];
            if ( c.sort == "asc" || c.sort == "dsc" ) return true;
            const filter = c.filter;
            const fo = utils.objIs( filter );
            const filterValue = fo  ? filter.value : filter;
            if ( filter !== false && filterValue !== null && filterValue !== "" ) return true;
          }
        }
      }

      return false;
    },

    filtersSortsApplied() {
      let html = "";
      let filters = "";
      let sorts = "";

      if ( this.columns ) {
        for ( const cid in this.columns ) {
          if ( this.columns.hasOwnProperty( cid ) ) {
            const c = this.columns[ cid ];
            if ( c.sort == "asc" || c.sort == "dsc" ) sorts += '<tr><td>' + c.name + '</td><td>' + this.$t( c.sort == "asc" ? "ascending" : "descending" ) + '</td></tr>';
            if ( c.show && c.filter ) {
              const filter = c.filter;

              let filterMode = this.$t( "columnFilters" ).modeEqual;
              let filterValue = filter;
              if ( utils.objIs( filterValue ) ) {
                filterMode = filter.modes[ filter.mode ].name;//.replace( /^[.=<>~]+\s+/, "" );
                filterValue = filter.value;
              }

              if ( filterValue ) filters += '<tr><td>' + c.name + '</td><td>' + filterMode + '</td><td>' + filterValue + '</td></tr>';
            }
          }
        }
      }

      if ( filters ) html += '<table cellspacing="0" cellpadding="0" border="0"><caption></caption><thead><tr><th scope="row" colspan="3">' + this.$t( "Filtering" ) + ':</th></tr></thead></tr><tr><th scope="row">' + this.$t( "Column" ) + '</th><th scope="row">' + this.$t( "Operation" ) + '</th><th scope="row">' + this.$t( "Value" ) + '</th></tr>' + filters + '</table>';
      if ( sorts ) html += ( html ? "<br />" : "" ) + '<table cellspacing="0" cellpadding="0" border="0"><caption></caption><thead><tr><th scope="row" colspan="2">' + this.$t( 'Sorting' ) + ':</th></tr></thead><tr><th scope="row">' + this.$t( "Column" ) + '</th><th scope="row">' + this.$t( "Operation" ) + '</th></tr>' + sorts + '</table>';

      if ( html ) html = '<div class="info">' + this.$t( "filtersSortsRemove" ) + '</div>' + html;

      return html;
    },

    endpointAndClass() {
      return this.endpointId + "|" + this.classId;
    }
  }
}
</script>

<style scoped>
.tableMain {
}

/*
.tableMain::v-deep > .table > tbody > tr > th {
  position: sticky;
  top: 0;
}

.tableMain::v-deep > .table {
  table-layout: fixed;
}

.tableMain::v-deep > .table > tbody {
  display: block;
  overflow: auto;
  width: 100%;
  height: 100%;
  max-width: 100vw;
  min-height: 20vw;
}

.tableMain::v-deep > .table > tbody > tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
*/

.tableMain::v-deep > .table {
  width: unset;
  min-width: 100%;
}
.tableMain::v-deep .row {
  cursor: pointer;
}

.tableMain::v-deep .cell:nth-child( 1 ) {
  width: 2em;
  text-align: center;
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.tableMain::v-deep .cell:nth-child( 2 ) {
  width: 7.5em;
  text-align: center;
  min-width: unset;
}

.tableMain::v-deep td.cell {
  vertical-align: top;
  min-width: 12em;
}
.tableUni::v-deep .table .row:hover {
  background-color: #EBF1F8;
}
.tableUni::v-deep .table .row:hover td.cell {
  background-color: unset;
}
.tableMain::v-deep td.cell.marked,
.tableMain::v-deep .row:hover td.cell.marked {
  background-color: #FFDBDB;
}
.tableMain::v-deep .cell.selection {
  text-align: center;
  width: 3em;
  min-width: 3em;
}
.tableMain::v-deep .cell .rowControls {
}
.tableMain::v-deep .cell .rowControls > * {
  width: 1.2em;
  height: 1.2em;
  margin: 0 0.2em;
}

.tableMain::v-deep .cell.controls {
  width: 8em;
  min-width: 8em;
  text-align: left;
  white-space: nowrap;
}
.tableMain::v-deep .cell.controls > button {
  margin: 0 0.5em;
}
.tableMain::v-deep .cell.controls > button:first-child {
  margin-left: 0;
}
.tableMain::v-deep .cell.controls > button:last-child {
  margin-right: 0;
}

.tableMain::v-deep .cell.vViolation {
  background: #FFD5D5 !important;
}
.tableMain::v-deep .cell.vWarning {
  background: #FFECC6 !important;
}
.tableMain::v-deep .cell.vInfo {
  background: #C0FFC0 !important;
}
.tableMain::v-deep .cell.consMandWarning {
  background: #D8EBFF !important;
}


.tableMain::v-deep td.cell > .right {
  text-align: right;
}

.control {
  position: relative;
}

.control.opened {
}

.control.opened.loading {
  pointer-events: none;
}

.control.opened.loading > .fields {
  opacity: 0.5;
}

.control > .inferred {
  margin-top: 0.2em;
  font-size: 0.8em;
  color: #808080;
}


.control > .fields::v-deep:before {
  box-shadow: 0 0 0 0.09em #6EB0E8, 0 0.2em 0.2em 0 rgba( 0, 0, 0, .35 )
}

.control > .fields::v-deep > .content {
  color: inherit;
  box-shadow: 0 0 0 0.07em #6EB0E8, 0 0.2em 0.2em 0 rgba( 0, 0, 0, .35 )
}

.control.opened.loading > .fields::v-deep > .content:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
	background: url( "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2400 2400' width='24' height='24'%3E%3Cg stroke-width='200' stroke-linecap='round' stroke='%23000' fill='none'%3E%3Cpath d='M1200 600V100'/%3E%3Cpath opacity='.5' d='M1200 2300v-500'/%3E%3Cpath opacity='.917' d='M900 680.4l-250-433'/%3E%3Cpath opacity='.417' d='M1750 2152.6l-250-433'/%3E%3Cpath opacity='.833' d='M680.4 900l-433-250'/%3E%3Cpath opacity='.333' d='M2152.6 1750l-433-250'/%3E%3Cpath opacity='.75' d='M600 1200H100'/%3E%3Cpath opacity='.25' d='M2300 1200h-500'/%3E%3Cpath opacity='.667' d='M680.4 1500l-433 250'/%3E%3Cpath opacity='.167' d='M2152.6 650l-433 250'/%3E%3Cpath opacity='.583' d='M900 1719.6l-250 433'/%3E%3Cpath opacity='.083' d='M1750 247.4l-250 433'/%3E%3CanimateTransform attributeName='transform' attributeType='XML' type='rotate' keyTimes='0;0.08333;0.16667;0.25;0.33333;0.41667;0.5;0.58333;0.66667;0.75;0.83333;0.91667' values='0 1199 1199;30 1199 1199;60 1199 1199;90 1199 1199;120 1199 1199;150 1199 1199;180 1199 1199;210 1199 1199;240 1199 1199;270 1199 1199;300 1199 1199;330 1199 1199' dur='0.83333s' begin='0s' repeatCount='indefinite' calcMode='discrete'/%3E%3C/g%3E%3C/svg%3E" ) 50% 50% no-repeat;
}

.control.opened > .fields {
  position: absolute;
  max-width: none;
  min-width: 16em;
  width: 100%;
  height: auto;
  z-index: 1;
  border-radius: 0.2em;
  padding: 0.5em;
/*  transition: opacity .35s ease;*/
  cursor: default;
}

.control.opened > .fields.inverted {
  left: unset;
  right: 1em;
}

.control.opened > .fields::v-deep > .content {
  display: inline-flex;
  flex-direction: column;
  width: 100%;
  background-color: #B5DDFF;
  padding-top: 1.5em;
}

.control.opened > .fields::before,
.control.opened > .fields::after {
  background-color: #B5DDFF;
}

.control.opened > .fields,
.control.opened > .fields * {
  font-size: inherit;
  font-family: inherit;
}

.control.opened > .fields .controls {
  position: absolute;
  top: 0;
  right: -0.2em;
  display: inline-block;
}

.control.opened > .fields .controls > * {
  padding-right: 0.5em;
  margin: 0;
}

.control.opened > .fields .field {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  flex-shrink: 1;
  margin: 0.2em 0;
  min-width: 5em;
}

.control.opened .fieldStandalone {
  padding: 0.2em 0.5em;
  position: relative;
  display: inline-block;
  box-shadow: inset 0 0 3px #000000;
  border-radius: 0.2em;
  font: inherit;
  flex-grow: 1;
  background-color: #FFFFFF;
  border: none;
}
.control.opened .fieldStandalone > * {
  border-radius: inherit;
  display: block;
  outline: none;
  height: 1.4em;
  width: 100%;
  background-color: transparent;
}

.control.opened > .fields .field > .lang {
  font-size: 0.8em;
  color: #808080;
  white-space: nowrap;
  word-break: keep-all;
  line-height: 2em;
  margin-right: 0.2em;
}
.control.opened > .fields .field > .fieldDV {
  flex-grow: 1;
  flex-shrink: 1;
  display: block;
}

.control.opened > .fields .field > button {
/*  margin: 0 0 0 1em;*/
  flex-grow: 0;
  flex-shrink: 0;
  position: relative;
}

.control.opened > .fields .field.empty > button:first-child {
  margin-left: 0;
}

/*
.fieldsEnter,
.fieldsLeaveTo {
  opacity: 0;
}
*/
button {
  border: none;
  padding: 0;
  background: none;
  cursor: pointer;
  line-height: 1em;
  margin: 0.5em;
}

button:hover,
button:hover * {
  transition: all .25s ease;
}

button:hover,
button:hover * {
  fill: var(--controlActiveColor) !important;
  stroke: var(--controlActiveColor) !important;
  color: var(--controlActiveColor) !important;
}










.errorTip,
.errorTip::v-deep * {
  font-size: inherit;
  font-family: inherit;
  overflow-wrap: normal;
  word-break: normal;
}

.errorTip {
  position: absolute;
  bottom: 0.8em;
  left: 0.5em;
  width: 16em;
}







.classes {
  width: 15em;
  margin-left: 0.2em;
  color: #000000;
}

.classes::v-deep *[data-focus] {
  border-radius: 0.2em;
  border: 0;
  padding: .2em 1em .2em .5em;
  box-shadow: inset 1px 1px 1px rgba( 0, 0, 0, 0.5 );
}

.classes::v-deep .results {
  border-radius: 0.2em;
  border: 0;
  box-shadow: 0 0 0 0.09em rgba( 0, 0, 0, .25 ), 0 0.2em 0.2em 0 rgba( 0, 0, 0, .35 );
	transform: translate( 0, 99% );
  color: #000000;
}

.classSelect::v-deep > .field,
.endpoint > select {
  padding: 0;
  border-radius: 0.2em;
  background-color: transparent;
	box-sizing: border-box;
  font: inherit;
  border: none;
  width: 100%;
  height: 1.2em;
  line-height: 1.2em;
}

.classSelect::v-deep > .field {
  width: 10em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
	box-sizing: border-box;
}

.endpoint,
.classSelect {
  display: inline-block;
  color: #000000;
  background-color: #FFFFFF;
  font: inherit;
	box-sizing: border-box;
  border-radius: 0.2em;
  position: relative;
 }

.endpoint::before,
.classSelect::before {
  position: absolute;
  top: -1.6em;
  left: 0;
  color: #FFFFFF;
  font-size: 0.8em;
}

.endpoint {
  width: 5em;
  margin-right: 1em;
  padding: 0.1em 0.2em;
}
.endpoint::before {
  content: attr( data-content );
}
.endpoint::after {
  content: "";
  position: absolute;
  width: 1em;
  height: 1.5em;
  right: 0.1em;
  top: 0;
  background-color: #FFFFFF;
  background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20viewBox%3D%220%200%2016%208%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0D%0A%20%3Cpath%20d%3D%22m0%200%208%208%208-8z%22%20%2F%3E%0D%0A%3C%2Fsvg%3E);
  background-size: 0.8em auto;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  pointer-events: none;
}

.classSelect {
  padding: 0.15em 0.2em 0.05em 0.2em;
  height: 1.5em;
}
.classSelect::before {
  content: attr( data-content );
}

.header > .hdrcontrol {
  margin-left: 2em !important;
}
.header > .hdrcontrol,
.header > .hdrcontrol > svg {
  color: #FFFFFF !important;
  fill: #FFFFFF !important;
}

.header > .hdrcontrol:hover {
  opacity: 0.8;
}
.control.opened > .fields::v-deep > .content {
  max-width: unset;
  min-width: 10em;
}
/*
.control.opened > .fields::v-deep > .content > .controls {
  right: 0.2em;
}
*/



.quality {
  display: inline-block;
  margin-left: 2em;
  animation: qualityShowA 300ms ease-in-out;
  border-radius: 0.2em;
  cursor: pointer;
}
@keyframes qualityShowA {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
.quality.active {
  background-color: #FF0000;
}
.quality .bar {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
}
.quality .bar .labelV,
.quality .bar .labelI {
  font-weight: bold;
  width: 3em;
  flex-grow: 0;
  flex-shrink: 0;
  text-align: center;
  color: #FFFFFF;
}

.quality .bar .band {
  border-radius: 0.2em;
  overflow: hidden;
  border: solid 2px #FFFFFF;
  white-space: nowrap;
  display: inline-block;
  height: 0.9em;
}
.quality .bar .band > * {
  box-sizing: border-box;
  vertical-align: top;
}
.quality .bar .band .valid,
.quality .bar .band .invalid {
  height: 100%;
  display: inline-block;
}
.quality .bar .band .valid {
  border-radius: 0.2em 0 0 0.2em;
  background-color: #00A600;
  border: solid #FFFFFF;
  border-width: 0 1px 0 0;
}
.quality .bar .band .invalid {
  background-color: #FF0000;
  border-radius: 0  0.2em 0.2em 0;
}
.quality .bar.validEmpty > .band *,
.quality .bar.invalidEmpty > .band * {
  border: none !important;
}

.quality .tip {
  font-weight: normal;
  cursor: default;
  z-index: 5100;
}
.quality .tip .hdr {
  font-weight: bold;
  margin-bottom: 0.5em;
}

.quality .tip .shapes {
  margin-top: 1em;
}
.quality .tip .shapes > .header {
  font-weight: bold;
}
.quality .tip .shapes > .shape {
  cursor: pointer;
  color: #40B8ED;
  margin-top: 0.2em;
  border-radius: 0.2em;
  border: solid 1px transparent;
  padding: 0 0.5em;
}
.quality .tip .shapes > .shape.OWV,
.quality .tip .shapes > .shape.ALL {
  font-weight: normal;
}
.quality .tip .shapes > .shape.OWV {
  margin-top: 1em;
}
.quality .tip .shapes > .shape > .name {
  text-decoration: underline;
}
.quality .tip .shapes > .shape:hover > .name {
  text-decoration: none;
}

.quality .tip .shapes > .shape.active {
  cursor: default;
  border-color: #FFFFFF;
}
.quality .tip .shapes > .shape.active > .name {
  text-decoration: none;
}

.quality .tip .shapes > .shape > .count {
  color: #FFFFFF;
  font-weight: bold;
  padding-left: 1em;
}

.header > .hdrcontrol.classMenu:hover {
  opacity: 1;
}
.header > .hdrcontrol.classMenuProcessingInf {
  width: 1em;
  height: 1em;
  position: relative;
}
.header > .hdrcontrol.classMenuProcessingInf svg {
  position: absolute;
  top: -0.5em;
  left: -0.5em;
  width: 2em;
  height: 2em;
}

.header > .hdrcontrol.classMenuProcessing {
  margin-left: 2.5em !important;
  font-size: 0.55em;
}

.duplicateFindingRules .rule {
  cursor: pointer;
  padding: 0.2em 1em;
  border-radius: 0.2em;
  margin: 0.2em 0;
}
.duplicateFindingRules .rule:hover {
  background-color: #F0F0F0;
}
.duplicateFindingRules .rule.selected {
  background-color: #007BC1;
  color: #FFFFFF;
}
.duplicateFindingRules.disableAccept::v-deep > .container > .footer .accept {
  opacity: 0.5;
  pointer-events: none;
}

.referencesRefreshing::v-deep > .container > .body > * {
  display: block;
  margin: 0.5em 0;
}

.objectViewModal::v-deep > .container {
  width: 90vw;
  height: 90vh;
  max-width: none;
  max-height: none;
}
.objectViewModal::v-deep > .container > .body {
  width: 100%;
  height: 100%;
  max-width: none;
  max-height: none;
}
</style>

<style>
.tableObjProps {
  border: solid 1px #E0E0E0;
  font-size: 0.8em;
  border-radius: 0.2em;
  min-width: 38em;
}

.tableObjProps th {
  font-weight: bold;
  color: #707070;
}

.tableObjProps tr:first-child {
  background-color: #F0F0F0;
}

.tableObjProps th,
.tableObjProps td {
  padding: 0.5em;
  text-align: left;
  border: solid 1px #E0E0E0;
  border-width: 0 1px 1px 0;
}
.tableObjProps th:last-child,
.tableObjProps td:last-child {
  border-right-width: 0;
}

.tableObjProps tr:nth-child(n+2):hover td,
.tableObjProps tr:nth-child(n+2):hover th {
  background-color: #0C97E7;
  color: #FFFFFF;
  border-color: #FFFFFF;
}

.tableObjProps tr:last-child th,
.tableObjProps tr:last-child td {
  border-bottom-width: 0;
}

button.hdrcontrol.filtersSortsApplied {
  opacity: unset !important;
  transition: unset !important;
  --controlActiveColor: #FFFFFF !important;
}
.hdrcontrol.filtersSortsApplied:hover > svg {
  opacity: 0.8 !important;
  transition: all .25s ease;
}
.hdrcontrol.filtersSortsApplied .info {
  font-size: 0.8em;
  font-weight: normal;
  margin-bottom: 1em;
}
.hdrcontrol.filtersSortsApplied table {
  width: 100%;
}
.hdrcontrol.filtersSortsApplied table td,
.hdrcontrol.filtersSortsApplied table th {
  padding: 0 0.5em;
  text-align: left;
  border: dotted #FFFFFF;
  border-width: 0 1px 1px 0;
}
.hdrcontrol.filtersSortsApplied table td:last-child,
.hdrcontrol.filtersSortsApplied table th:last-child {
  border-right-width: 0;
}
.hdrcontrol.filtersSortsApplied table tr:last-child th,
.hdrcontrol.filtersSortsApplied table tr:last-child td {
  border-bottom-width: 0;
}
.hdrcontrol.filtersSortsApplied table th {
  font-weight: bold;
  border-bottom-style: solid;
}
.hdrcontrol.filtersSortsApplied table thead th {
  padding-bottom: 0.5em;
  text-transform: uppercase;
}
.hdrcontrol.filtersSortsApplied .sort {
  margin-top: 0.5em;
}

.group {
  display: table;
  position: relative;
}

.schedulerControls {
  padding: 1em 0 0 0;
  margin: 1em 0 0 0;
}
.schedulerControls .button {
  font-size: 0.8em;
  background-color: #007BC1;
  color: #FFFFFF;
  fill: #FFFFFF;
  display: inline-block;
  border-radius: 0.2em;
  padding: 0.5em 1em;
  cursor: pointer;
  margin: 0 2em 2em 0;
  border: 1px solid #007BC1;
  transition: all .5s ease;
}
.schedulerControls .button * {
  transition: none;
}
.schedulerControls .button:hover {
  background-color: #0C97E7;
}

.schedulerXLSimport {
  min-width: 20em;
}
</style>
